var _polygon, _path, _path2, _polygon2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrPolicies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.1,220.37l-3.45.19-8.11-10.07-.38-6.88s-5.35,0-4.22,8.95.32,6.72.32,6.72S237,220,236.06,221c-.64.76-.32,12-.1,18.12a6.59,6.59,0,0,0,5,6.38,4.68,4.68,0,0,0,1.23.1c2.82-.16,17.11-3.25,17.11-3.25l6-.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.86 217.93 273.05 241.63 267.15 241.96 265.87 218.85 273.86 217.93",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.9,303.16l4.27.24,10-12.46.48-8.52s6.61,0,5.22,11.07-.4,8.32-.4,8.32,14,.83,15.09,2.11c.8.93.41,14.86.14,22.41a8.19,8.19,0,0,1-6.25,7.91,6,6,0,0,1-1.52.12c-3.49-.2-21.17-4-21.17-4l-7.37-.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.82 300.14 491.82 329.47 499.13 329.88 500.72 301.28 490.82 300.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.36,357.77a27.78,27.78,0,0,0-11.9-4.1c-2-.2-4.07-.14-5.63,1a1.13,1.13,0,0,0-.58,1,1.21,1.21,0,0,0,.55.7,17,17,0,0,0,17.56,1.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.06,357.43a57.61,57.61,0,0,1-7.69-6.76,19.41,19.41,0,0,1-4.82-8.92,3.58,3.58,0,0,1,.38-3c6.13,4.78,10.94,11,12.13,18.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.3,357.72a27.81,27.81,0,0,1,.14-10.09,13.68,13.68,0,0,1,5.38-8.34c1.06,2.48.61,5.33-.14,7.92a38.38,38.38,0,0,1-5.33,11.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.31,368.49a17.6,17.6,0,0,0-9.55,4.83,18.08,18.08,0,0,0-5.46,9.38c3.58-.22,6.61-2.74,8.81-5.57s3.73-5.94,6.15-8.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.61,370.21a23.57,23.57,0,0,1,2.72-22.27c2.08,7.39,1.32,15.74-2.72,22.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.55,379.67A17,17,0,0,0,194.27,389c-.2.4-.38.92-.11,1.28a1.24,1.24,0,0,0,1.08.32c3.21-.21,6.06-2.14,8.4-4.34s4.39-4.74,7-6.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3,379.15a30.31,30.31,0,0,1-.3-16.94c.6-2.18,1.6-4.47,3.61-5.5a.75.75,0,0,1,.56-.09.73.73,0,0,1,.35.4,10.34,10.34,0,0,1,.85,4.86,30.32,30.32,0,0,1-.76,4.92c-.64,3-1,6.24-2.62,8.83a16.54,16.54,0,0,0-1.05,1.94c-.32.66-.32.89-.6,1.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.32,382.28a21.81,21.81,0,0,1,3.83-18c.27-.35.64-.74,1.09-.69.68.06.86,1,.83,1.66a32.44,32.44,0,0,1-5.75,17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.21,383.58a26.14,26.14,0,0,0,21.44-4.36,17.31,17.31,0,0,0-11.6-1.42,16.55,16.55,0,0,0-9.84,5.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.81,379.64a24.75,24.75,0,0,1,19.46-11.25,12,12,0,0,1-6.37,7,35.24,35.24,0,0,1-9.34,2.73c-1.24.24-2.94.51-3.75,1.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.72,360.5a56.61,56.61,0,0,0,2.49-11.4,19,19,0,0,0-2.27-11.27,24.78,24.78,0,0,0-.33,23.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.39,354.09c4.41-8,13.39-14.39,22.48-15.29-3.51,8.73-13.07,15.48-22.48,15.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.62,355.66c6.57,1,12.16,5.19,18.3,7.74a8.29,8.29,0,0,0,4.14.79,3.24,3.24,0,0,0,2-5.73,8.76,8.76,0,0,0-3-1.82c-6.68-2.78-13.85-2.85-20.89-1.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.83,360.27c1.48.42,2,1.19,3.17,2.19a34.27,34.27,0,0,0,13.87,7.13c.53.13,1.23.18,1.49-.29s-.06-.93-.36-1.3a19.08,19.08,0,0,0-8.38-5.69c-3.2-1.19-6-2.63-9.79-2.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.54,332.45a26.25,26.25,0,0,0,20.13,6.85,1.32,1.32,0,0,0,.91-.33c.51-.55-.1-1.4-.69-1.86-5.92-4.61-13.08-6.53-20.35-4.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.62,330.59a28,28,0,0,1,25.12-4.14,19.91,19.91,0,0,1-12,5.25,37.89,37.89,0,0,1-13.15-1.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.6,317.81c-.58-5.91-.2-10.57-.61-16.5,0-.48-.14-1.05-.58-1.22-.62-.24-1.13.52-1.34,1.15a18.94,18.94,0,0,0,2.52,16.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.18,318.46A34.72,34.72,0,0,0,246,309c1.93-2.64,3.56-5.81,3.12-9.05a9.37,9.37,0,0,0-7.06,3.5,19.68,19.68,0,0,0-3.59,7.24c-.79,2.6-1.34,5.27-2.25,7.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.79,315.79a78.84,78.84,0,0,0,24.08-14.2c-2.88-1.16-6.17-.46-9.05.7a28.54,28.54,0,0,0-15.16,13.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.88,321.7a49.08,49.08,0,0,0,13.37.06,56.12,56.12,0,0,0,12.48-4.15,1.47,1.47,0,0,0,.85-.64,1,1,0,0,0-.3-1.07,2.77,2.77,0,0,0-1.07-.5,23.15,23.15,0,0,0-13.49.81,62.65,62.65,0,0,0-11.84,5.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5,332.65a23.61,23.61,0,0,1-.22-19.57c1.84,2.81,2.07,6.39,1.73,9.73s-1.35,6.79-1.42,10.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.38,326.54a27.33,27.33,0,0,0-20.29,8.65,19,19,0,0,0,11.11-2.06,56.52,56.52,0,0,0,9.52-6.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.23,323.82c-3.7-.3-7.27-.76-10.83.33a13,13,0,0,0-8.25,7,19.55,19.55,0,0,0,10.15-1.92,58,58,0,0,0,8.93-5.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.29,323.94c-3.33-2.18-6.75-4.4-10.63-5.31s-8.38-.23-11.08,2.69c3.14,1.84,6.95,2.06,10.59,2.06s8.11-.05,11.54,1.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.31,324.12c-5.69-5.59-7.85-15.64-5.56-23.29a35.46,35.46,0,0,1,5.56,23.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,308.27c1.07-2.5,1.83-5.12,2.79-7.66a22.14,22.14,0,0,1,4-7.07,10.45,10.45,0,0,1,7.05-3.65,28.44,28.44,0,0,1-13.69,18.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,311.57c-1.78-2.45-3.84-5.77-6.25-7.59s-5.55-2.94-8.49-2.24a19.77,19.77,0,0,0,14.74,9.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.71,308.47a42.4,42.4,0,0,1-2.81-9.1,14.18,14.18,0,0,1,1.43-9.25c3.12,5.91,4.13,12.25,1.54,18.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,290.12c1.77-5.86,7.14-10.18,12.93-12.16a4.79,4.79,0,0,1,2.27-.34,2,2,0,0,1,1.67,1.39c.21,1-.61,1.9-1.39,2.56A44.06,44.06,0,0,1,221,290.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.07,285.32c.23-3.78.46-7.61,1.69-11.19s3.6-6.94,7.05-8.5c.58,3.81-1.1,7.61-3.13,10.89s-4.48,6.39-5.7,10.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,287.92c-1.46-4.27-1.62-9.69-4.17-13.41-1.79-2.6-4.65-4.38-6.19-7.13a10.81,10.81,0,0,0,.36,8.09,23.29,23.29,0,0,0,4.73,6.77c1.89,2,3.51,3.55,5.27,5.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,413.7c-.12,0-.21-28.49-.22-63.63s.08-63.63.19-63.63.21,28.48.22,63.63S221.12,413.7,221,413.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.91,328.35a6.72,6.72,0,0,1-1.07.41l-3,1c-2.49.85-5.9,2.07-9.61,3.59s-7.13,2.86-9.1,4.56a6.74,6.74,0,0,0-1.83,2.42c-.28.67-.33,1.08-.37,1.07a.91.91,0,0,1,0-.29,4.2,4.2,0,0,1,.21-.84,6.39,6.39,0,0,1,1.79-2.57,15.84,15.84,0,0,1,3.95-2.46c1.57-.73,3.33-1.5,5.18-2.27,3.72-1.52,7.16-2.71,9.68-3.48,1.25-.4,2.28-.69,3-.88A8,8,0,0,1,245.91,328.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.07,308.31a2.12,2.12,0,0,1-.3.32l-.92.86-3.41,3.1L238.08,322.7c-4.43,3.95-8.27,7.72-10.92,10.56-1.33,1.42-2.38,2.59-3.09,3.42l-.83.94a1.74,1.74,0,0,1-.31.31,2.2,2.2,0,0,1,.25-.36c.17-.23.42-.57.76-1,.68-.85,1.7-2.06,3-3.51a144,144,0,0,1,10.87-10.66c4.45-3.94,8.5-7.48,11.44-10l3.5-3,1-.8A2,2,0,0,1,254.07,308.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.29,326.72c-.11-.05.81-2.19,1.74-4.9s1.37-5,1.48-5a16.56,16.56,0,0,1-1.09,5.1,36,36,0,0,1-1.38,3.43A5.65,5.65,0,0,1,233.29,326.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,344a5,5,0,0,1-.68-.79l-1.75-2.25c-1.47-1.9-3.5-4.52-5.78-7.39s-4.37-5.45-5.89-7.31L205.14,324a4.94,4.94,0,0,1-.62-.84,4.43,4.43,0,0,1,.74.74c.46.49,1.1,1.22,1.89,2.13,1.58,1.82,3.71,4.37,6,7.24s4.28,5.53,5.69,7.48c.71,1,1.27,1.77,1.65,2.32A4.67,4.67,0,0,1,221,344Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.58,337a9.84,9.84,0,0,1-2.29-4.28,12.3,12.3,0,0,1-.52-4.32l.18,0c-.08.33-.14.5-.17.5s0-.19,0-.53l.18,0a20.34,20.34,0,0,0,.73,4.19A31.49,31.49,0,0,0,215.58,337Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,328.09a7,7,0,0,0-1.6-.93,10.74,10.74,0,0,0-4.43-.35,27.12,27.12,0,0,0-4.47.72,12.73,12.73,0,0,1-1.83.44,6,6,0,0,1,1.75-.72,20.47,20.47,0,0,1,4.52-.85,9.58,9.58,0,0,1,4.57.49A2.89,2.89,0,0,1,208.53,328.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.86,325.94c0,.06-.93-.37-2.45-.89a24.51,24.51,0,0,0-12.33-.94c-1.58.28-2.53.58-2.55.51a2,2,0,0,1,.65-.28,14.44,14.44,0,0,1,1.85-.52,21.8,21.8,0,0,1,12.48.95,16.66,16.66,0,0,1,1.75.8C206.66,325.78,206.87,325.91,206.86,325.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,316.85a49.6,49.6,0,0,1-1.78-6.19,51,51,0,0,1-1.39-6.3,50.57,50.57,0,0,1,1.79,6.19A51.93,51.93,0,0,1,221,316.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.09,316.85a29.28,29.28,0,0,0-2-3.71,17.19,17.19,0,0,0-2.91-3,2.66,2.66,0,0,1,1.12.58,9.08,9.08,0,0,1,2.12,2.19A8.12,8.12,0,0,1,221.09,316.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,398.51s-.13-.68-.45-1.89a27.91,27.91,0,0,0-1.9-4.94,68.18,68.18,0,0,0-10.11-14.23c-2.25-2.57-4.44-5-6.3-7.33a51.14,51.14,0,0,1-4.5-6.5,32.07,32.07,0,0,1-2.28-4.82c-.21-.6-.36-1.06-.44-1.38a3,3,0,0,1-.12-.49s.24.65.71,1.81a35.73,35.73,0,0,0,2.38,4.73,53.86,53.86,0,0,0,4.55,6.41c1.86,2.3,4,4.72,6.31,7.3a64.58,64.58,0,0,1,10.06,14.38,24.64,24.64,0,0,1,1.79,5A12.2,12.2,0,0,1,221,398,2.69,2.69,0,0,1,221,398.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.51,373.1a10.67,10.67,0,0,1-1.18.66,26.41,26.41,0,0,0-3.06,2,35.39,35.39,0,0,0-4,3.67c-1.41,1.49-2.86,3.22-4.34,5.07-3,3.72-5.74,7-7.4,9.63-.84,1.31-1.45,2.4-1.85,3.18a10.68,10.68,0,0,1-.65,1.18,1.07,1.07,0,0,1,.11-.33c.09-.21.2-.53.39-.93a30.32,30.32,0,0,1,1.76-3.25,105.12,105.12,0,0,1,7.32-9.74c1.48-1.86,2.95-3.59,4.39-5.08a32.56,32.56,0,0,1,4.12-3.63,21.31,21.31,0,0,1,3.15-1.93c.39-.2.71-.32.92-.41A1.57,1.57,0,0,1,243.51,373.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,381.34a17.07,17.07,0,0,1-2.49.37,32.05,32.05,0,0,0-5.92,1.16,17.74,17.74,0,0,0-5.29,2.78c-1.22.94-1.79,1.72-1.85,1.67a2,2,0,0,1,.37-.57,9.67,9.67,0,0,1,1.3-1.33,16,16,0,0,1,5.35-2.94,26.1,26.1,0,0,1,6-1.06A13.84,13.84,0,0,1,244,381.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.13,386.42c-.13-.07,1-1.79,1.86-4.1s1-4.37,1.16-4.34a4,4,0,0,1,0,1.33,14.54,14.54,0,0,1-.73,3.15,15.11,15.11,0,0,1-1.45,2.89A4,4,0,0,1,229.13,386.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.79,351a2.2,2.2,0,0,1-.39.21l-1.18.53c-.51.22-1.13.5-1.83.87s-1.53.74-2.38,1.25l-1.36.77c-.48.28-.94.6-1.44.91-1,.61-2,1.36-3.08,2.12a52.83,52.83,0,0,0-11.85,12.27c-.73,1.09-1.44,2.12-2,3.15-.29.5-.6,1-.85,1.46s-.5.94-.73,1.39c-.48.87-.83,1.7-1.17,2.42s-.6,1.34-.8,1.86l-.49,1.19a2.75,2.75,0,0,1-.2.41,1.53,1.53,0,0,1,.12-.43c.11-.33.25-.73.42-1.22s.42-1.18.74-1.9.65-1.58,1.12-2.46l.71-1.41c.25-.49.55-1,.84-1.49.56-1,1.27-2.08,2-3.19a50.56,50.56,0,0,1,11.94-12.36c1.08-.76,2.1-1.5,3.12-2.1.5-.31,1-.62,1.45-.89l1.39-.75c.87-.5,1.7-.86,2.42-1.21s1.35-.61,1.87-.81l1.2-.46A1.49,1.49,0,0,1,250.79,351Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,362.9a2.8,2.8,0,0,1,1-1.46,6.15,6.15,0,0,1,3.94-1.51,10.56,10.56,0,0,1,4.15.81,5.63,5.63,0,0,1,1.57.76A9.4,9.4,0,0,1,242,361a12.41,12.41,0,0,0-4.05-.67,6.39,6.39,0,0,0-3.76,1.32A10.65,10.65,0,0,0,233,362.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,365.64a15.11,15.11,0,0,0,1.12-3.64,15.4,15.4,0,0,0-.25-3.81,2.71,2.71,0,0,1,.46,1.07,7.69,7.69,0,0,1,.2,2.79,7.5,7.5,0,0,1-.84,2.67C230.67,365.35,230.37,365.67,230.33,365.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.33,402.59c.61,10.89,3.9,22,8.94,33.16h21.95c4.81-11.08,7.87-22.14,8.41-33.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.07,420.21c0,.12-7.22.21-16.13.21s-16.14-.09-16.14-.21,7.22-.2,16.14-.2S237.07,420.1,237.07,420.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.58,424.16c0,.11-6.77.2-15.13.2s-15.13-.09-15.13-.2,6.78-.21,15.13-.21S236.58,424,236.58,424.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63,409.74a64,64,0,0,1,0,10.11,60.95,60.95,0,0,1,0-10.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.39,409.74a68.61,68.61,0,0,1,0,10.47,65.36,65.36,0,0,1,0-10.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.42,409.66a67.87,67.87,0,0,1,0,10.67,71.26,71.26,0,0,1,0-10.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.93,409.74c0,.12-8.47.21-18.92.21s-18.93-.09-18.93-.21,8.47-.2,18.93-.2S239.93,409.63,239.93,409.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.11,
    y: 84.69,
    width: 89.76,
    height: 148.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.13,
    y: 84.69,
    width: 89.76,
    height: 148.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.95,
    y: 87.7,
    width: 82.12,
    height: 142.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.58,
    y: 106.23,
    width: 50.5,
    height: 105.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.58,174.4c-.12-9.85,8.75-19.48,18.51-20.85,4.65-.66,9.6.27,13.94-1.52,7.77-3.18,10.24-13.49,18.05-16.55l.35,76.26H471.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.1,376.3A16.77,16.77,0,0,1,694.5,375a8.66,8.66,0,0,1,5.13,2.29c1.29,1.42,1.53,3.91.06,5.13a4.86,4.86,0,0,1-3.24.82c-2.75,0-5.8-.51-8,1.14-1.25.95-2.09,2.51-3.58,3a3.55,3.55,0,0,1-3.9-1.73,6.06,6.06,0,0,1-.44-4.47A6.83,6.83,0,0,1,684.1,376.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.85,362.31c1.93,2.76,5.69,1.85,7.44.16s2.48-4.13,3.15-6.46c1.53-5.32,3.07-10.91,1.93-16.33a9,9,0,0,0-2.08-4.44,4.74,4.74,0,0,0-4.5-1.5c-1.89.5-3.07,2.36-3.92,4.13A39,39,0,0,0,675,354.58c0,2.69.31,5.51,1.83,7.73",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.54,366.28A10.07,10.07,0,0,0,673.1,357a17.79,17.79,0,0,0-5.48-7.95,29.43,29.43,0,0,0-9.81-5.79,10.5,10.5,0,0,0-4.41-.75,4.64,4.64,0,0,0-3.71,2.24c-1,2,0,4.36,1,6.31a75.75,75.75,0,0,0,6.45,9.81c1.93,2.49,4.14,5,7.08,6.07s6,1,7.57-1.05",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.72,404a7.1,7.1,0,0,0,.17-1.26c.09-.91.2-2.06.34-3.42a49.51,49.51,0,0,1,.77-5,39.27,39.27,0,0,1,1.82-5.93,21.93,21.93,0,0,1,3-5.37,11.46,11.46,0,0,1,3.83-3.18,10.61,10.61,0,0,1,3.23-1,6,6,0,0,0,1.25-.19,6.29,6.29,0,0,0-1.28,0,9.75,9.75,0,0,0-3.36.87,11.35,11.35,0,0,0-4,3.21,21.47,21.47,0,0,0-3.14,5.48,36.62,36.62,0,0,0-1.81,6,42.13,42.13,0,0,0-.67,5.09c-.11,1.46-.15,2.64-.17,3.45A5.27,5.27,0,0,0,676.72,404Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677,401.35a2.39,2.39,0,0,0,0-.58c0-.44,0-1,0-1.67,0-1.44,0-3.53.08-6.12.12-5.16.57-10.72,1.43-18.56.81-7.38,1.9-15.95,3.06-21.53.24-1.27.49-2.41.73-3.41s.41-1.87.6-2.57.28-1.19.39-1.62a3.26,3.26,0,0,0,.1-.57,2.3,2.3,0,0,0-.21.55c-.12.42-.28.94-.48,1.59s-.43,1.55-.68,2.55-.54,2.14-.81,3.4a189.91,189.91,0,0,0-3.22,20c-.86,7.85-1.25,15-1.28,20.19,0,2.59,0,4.68.09,6.13,0,.67.08,1.23.1,1.66A3.39,3.39,0,0,0,677,401.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677,387.56a12.25,12.25,0,0,0,0-1.74c-.07-1.12-.22-2.74-.54-4.72a62.21,62.21,0,0,0-1.53-6.87,56.44,56.44,0,0,0-2.87-8.12A43.27,43.27,0,0,0,663.6,353a20.11,20.11,0,0,0-2-1.84c-.31-.26-.58-.52-.85-.72l-.77-.53a11.7,11.7,0,0,0-1.46-.94,52.79,52.79,0,0,1,4.8,4.28,45.83,45.83,0,0,1,8.22,13.09,63.73,63.73,0,0,1,2.89,8.05c.75,2.53,1.25,4.85,1.63,6.8s.57,3.56.69,4.67A11.11,11.11,0,0,0,677,387.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "663.65 411.89 665.04 430.83 689.37 430.83 690.75 411.89 663.65 411.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.3,
    y: 404.43,
    width: 32.35,
    height: 7.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.3 430.11 661.3 432.18 662.82 432.18 693.12 432.18 693.12 430.11 661.3 430.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.31 435.82 662.82 432.18 691.96 432.18 690.22 435.82 664.31 435.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.3,418.08a1.13,1.13,0,0,1-.12.18l-.36.48-1.42,1.81-.06.08-.06-.08-3.48-4.82h.2l-3.43,4.86-.11.15-.12-.14c-1.26-1.51-2.64-3.14-4.07-4.84h.24l-.22.29-3.64,4.55-.12.16-.11-.16L670,415.73h.2L666,420.56l-.07.08-.06-.09-1.32-2.23-.34-.59a1.37,1.37,0,0,1-.11-.21.86.86,0,0,1,.15.19c.09.15.22.34.37.57.34.53.81,1.26,1.39,2.18h-.13l4.15-4.87.11-.13.09.14,3.46,4.83h-.23l3.63-4.56.22-.28.12-.15.12.14,4,4.85h-.23c1.25-1.75,2.42-3.37,3.47-4.83l.1-.14.1.14,3.41,4.87h-.13l1.48-1.76.39-.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.09,411.77c0,.08-6.1.15-13.62.15s-13.61-.07-13.61-.15,6.09-.15,13.61-.15S691.09,411.68,691.09,411.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.32,432.38c0,.08-6.63.15-14.8.15s-14.8-.07-14.8-.15,6.63-.15,14.8-.15S692.32,432.3,692.32,432.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.74,
    y: 118.22,
    width: 33.29,
    height: 54.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.32,
    y: 118.22,
    width: 35.97,
    height: 54.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.32,
    y: 176.64,
    width: 35.97,
    height: 52.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.9 117.28 143.78 117.28 143.78 68.84 145.06 68.84 145.06 117.28 175.89 117.28 175.89 67.76 105.9 67.76 105.9 117.28",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.06,
    y: 118.22,
    width: 30.83,
    height: 54.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.06,
    y: 176.64,
    width: 30.83,
    height: 52.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.74,
    y: 176.64,
    width: 33.29,
    height: 52.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 176.64,
    width: 37.88,
    height: 52.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.74,
    y: 230.35,
    width: 33.29,
    height: 47.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.06,
    y: 230.35,
    width: 30.83,
    height: 47.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.04 117.28 64.04 68.84 65.32 68.84 65.32 117.28 101.29 117.28 101.29 67.76 30.74 67.76 30.74 117.28 64.04 117.28",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 230.35,
    width: 37.88,
    height: 47.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.32,
    y: 230.35,
    width: 35.97,
    height: 47.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 118.22,
    width: 37.88,
    height: 54.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.26,
    y: 117.14,
    width: 33.29,
    height: 54.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.83,
    y: 117.14,
    width: 35.97,
    height: 54.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.83,
    y: 175.56,
    width: 35.97,
    height: 52.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "647.41 116.2 685.3 116.2 685.3 67.76 686.58 67.76 686.58 116.2 717.41 116.2 717.41 66.68 647.41 66.68 647.41 116.2",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.58,
    y: 117.14,
    width: 30.83,
    height: 54.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.58,
    y: 175.56,
    width: 30.83,
    height: 52.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.26,
    y: 175.56,
    width: 33.29,
    height: 52.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.41,
    y: 175.56,
    width: 37.88,
    height: 52.76,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.26,
    y: 229.27,
    width: 33.29,
    height: 47.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.58,
    y: 229.27,
    width: 30.83,
    height: 47.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "605.55 116.2 605.55 67.76 606.83 67.76 606.83 116.2 642.8 116.2 642.8 66.68 572.26 66.68 572.26 116.2 605.55 116.2",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.41,
    y: 229.27,
    width: 37.88,
    height: 47.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.83,
    y: 229.27,
    width: 35.97,
    height: 47.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.41,
    y: 117.14,
    width: 37.88,
    height: 54.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.99 103.63 313.99 179.2 205.45 179.2 201.54 104.16 313.99 103.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.37,
    y: 87.33,
    width: 74.88,
    height: 108.54,
    transform: "translate(114.21 397.41) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.3,
    y: 113.46,
    width: 85.03,
    height: 56.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.33,113.46l-.42,0H296.7l-4.67,0-17.52.07-61.21.12.25-.25c0,17.2,0,36.25,0,56.27h0l-.27-.27,85,.05-.22.22c.05-17.13.09-31.17.12-41,0-4.88,0-8.7,0-11.32,0-1.29,0-2.29,0-3s0-1,0-1,0,.33,0,1,0,1.66,0,2.94c0,2.6,0,6.4.06,11.27,0,9.81.06,23.9.11,41.08V170h-.21l-85,.06H213v-.27h0c0-20,0-39.07,0-56.27v-.24h.25l61.37.12,17.46.06,4.62,0,1.19,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.54,104a9,9,0,0,1,1.87,1.21c1.11.8,2.62,1.94,4.25,3.24s3.07,2.55,4.08,3.47a8.84,8.84,0,0,1,1.56,1.59c-.1.12-2.71-2-6-4.64A61.34,61.34,0,0,1,201.54,104Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.08,104.16a52,52,0,0,1-5.71,4.86,52.55,52.55,0,0,1-6,4.44A52.16,52.16,0,0,1,304,108.6,51.56,51.56,0,0,1,310.08,104.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,179.05l-12.11-9.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.89,169.24a56.77,56.77,0,0,1,6.22,4.7,57.92,57.92,0,0,1,5.89,5.11,54.38,54.38,0,0,1-6.22-4.69A55.83,55.83,0,0,1,297.89,169.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.54,179a52.33,52.33,0,0,1,5.66-4.81,51.13,51.13,0,0,1,6-4.39,51.44,51.44,0,0,1-5.65,4.81A49.78,49.78,0,0,1,201.54,179Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.89,
    y: 113.67,
    width: 18.84,
    height: 53.5,
    transform: "translate(116.9 397.73) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.34,436.14c0,.14-153.28.26-342.32.26s-342.36-.12-342.36-.26,153.25-.26,342.36-.26S717.34,436,717.34,436.14Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--spotlight-2--inject-245"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.36,
    y: 14.39,
    width: 5.98,
    height: 16.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.86,65.19c.09-.66,9.36-37.53,9.36-37.53,9.57-4.42,19.37-4.23,29.37,0L403,65.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.07 65.19 355.87 65.25 250.35 458.85 506.48 461.08 403.07 65.19",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.07 65.31 355.87 65.37 250.35 458.85 506.48 461.2 403.07 65.31",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 379.43,
    cy: 65.19,
    rx: 23.56,
    ry: 7.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,65.19a5.37,5.37,0,0,0-.26-1,5.23,5.23,0,0,0-2-2.24c-2.15-1.55-5.85-2.85-10.52-3.65a66.85,66.85,0,0,0-16.61-.6A50,50,0,0,0,364,59.43a21.61,21.61,0,0,0-4.76,2A9.06,9.06,0,0,0,357.15,63a3.37,3.37,0,0,0-1,2.23,3.33,3.33,0,0,0,1,2.23A9,9,0,0,0,359.2,69,21.89,21.89,0,0,0,364,71a50,50,0,0,0,9.66,1.75,66.48,66.48,0,0,0,16.62-.6c4.66-.8,8.36-2.1,10.51-3.64a5.3,5.3,0,0,0,2-2.25,5.17,5.17,0,0,0,.26-1,2.34,2.34,0,0,1-.16,1.06,5.26,5.26,0,0,1-1.95,2.37c-2.16,1.63-5.88,3-10.57,3.84a65,65,0,0,1-16.73.71,49.15,49.15,0,0,1-9.76-1.73,23.22,23.22,0,0,1-4.88-2,9.91,9.91,0,0,1-2.18-1.66,3.46,3.46,0,0,1,0-5.18A9.39,9.39,0,0,1,359,60.94a22.93,22.93,0,0,1,4.87-2,49.88,49.88,0,0,1,9.76-1.73,65.45,65.45,0,0,1,16.73.71c4.69.85,8.41,2.21,10.57,3.84a5.26,5.26,0,0,1,1.95,2.37A2.34,2.34,0,0,1,403,65.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.43,
    cy: 459.89,
    rx: 128.38,
    ry: 25.72,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.43,
    cy: 459.89,
    rx: 128.38,
    ry: 25.72,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.87,478.89s4.14,2.46,10.43-.77,15.81-11.35,19.81-11,3.06-.2,9.91,2.95,14.94,3.4,25.54,1.55,17.66-2.67,13.77-7.15S423,457.65,419,455.66s-39.4-2-41.58-.3S360.87,478.89,360.87,478.89Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.37,74.58A8,8,0,0,1,394,75c-.91.22-2.24.48-3.9.72A63.43,63.43,0,0,1,377,76.2,62.64,62.64,0,0,1,364.12,74c-1.62-.45-2.91-.87-3.78-1.21a8.13,8.13,0,0,1-1.34-.56,8.48,8.48,0,0,1,1.41.37c.89.27,2.19.64,3.8,1.05a72.31,72.31,0,0,0,12.83,2,72.51,72.51,0,0,0,13-.36c1.66-.2,3-.4,3.91-.56A7.25,7.25,0,0,1,395.37,74.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.52,434.18l-.23,0-.68.05-2.6.13c-1.14.05-2.52.13-4.13.23s-3.43.2-5.45.36c-8.08.59-19.22,1.65-31.46,3.34s-23.26,3.68-31.16,5.47c-3.95.9-7.12,1.73-9.3,2.34l-2.5.72-.65.18c-.15,0-.23.05-.23,0a1,1,0,0,1,.21-.09l.64-.23,2.48-.82c2.16-.67,5.32-1.55,9.27-2.5,7.89-1.88,18.91-3.95,31.17-5.62s23.42-2.7,31.51-3.2c2-.13,3.85-.22,5.46-.28s3-.13,4.13-.14l2.61,0h.68A.6.6,0,0,1,355.52,434.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.06,179.49l2-6.12a20.32,20.32,0,0,1-3.44-10.64,20.57,20.57,0,1,1,8.57,16h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.06,179.49l.48-.06,1.38-.17,5.31-.64-.05.11h0a.06.06,0,0,1,0-.09.06.06,0,0,1,.07,0,20.53,20.53,0,0,0,9.45,3.66,19.36,19.36,0,0,0,3.17.13,23.5,23.5,0,0,0,3.36-.41,20.42,20.42,0,0,0,10.9-33.92,20.29,20.29,0,0,0-8.24-5.37,20.81,20.81,0,0,0-9.34-1,20.21,20.21,0,0,0-8.32,3,20.57,20.57,0,0,0-8.92,12.5c-.06.29-.12.58-.19.86a6,6,0,0,0-.14.85c-.07.56-.14,1.12-.2,1.67a28.05,28.05,0,0,0,0,3.19,20.47,20.47,0,0,0,3.32,9.51,0,0,0,0,1,0,0c-.67,2-1.18,3.49-1.54,4.52-.17.52-.31.91-.4,1.18s-.15.4-.15.4l.12-.38c.09-.27.21-.66.38-1.17.34-1.05.83-2.59,1.48-4.58v0a20.43,20.43,0,0,1-3.41-9.56,26.36,26.36,0,0,1-.05-3.22c.06-.56.12-1.12.19-1.69a6.17,6.17,0,0,1,.14-.86c.06-.29.13-.58.19-.87a20.61,20.61,0,0,1,9-12.67,20.32,20.32,0,0,1,8.42-3.08,21,21,0,0,1,9.48,1,20.47,20.47,0,0,1,8.35,5.45,9.2,9.2,0,0,1,.82.94l.78,1,.68,1a7.66,7.66,0,0,1,.64,1.06l.58,1.09a11.09,11.09,0,0,1,.48,1.12c.15.38.32.75.45,1.13s.23.78.34,1.16a20.62,20.62,0,0,1-15.84,25.81,22.66,22.66,0,0,1-3.4.41,19.61,19.61,0,0,1-3.19-.15,20.56,20.56,0,0,1-9.5-3.74l.09-.09h0a.06.06,0,0,1,0,.09l0,0-5.36.56-1.36.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.71 162.52 438.58 159.35 444.67 164.24 453.72 153.85 456.68 156.73 444.53 170.09 435.71 162.52",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--spotlights-1--inject-245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.24,65.19c.08-.66,9.35-37.53,9.35-37.53,9.58-4.42,19.38-4.23,29.37,0l8.4,37.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.8,
    cy: 65.19,
    rx: 23.56,
    ry: 7.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,65.19a5.71,5.71,0,0,0-.25-1,5.3,5.3,0,0,0-2-2.24c-2.15-1.55-5.85-2.85-10.52-3.65a67,67,0,0,0-16.62-.6,50.11,50.11,0,0,0-9.66,1.75,22,22,0,0,0-4.76,2A9.06,9.06,0,0,0,108.52,63a3.42,3.42,0,0,0-1,2.23,3.37,3.37,0,0,0,1,2.23A9.06,9.06,0,0,0,110.58,69a21.61,21.61,0,0,0,4.76,2A50,50,0,0,0,125,72.7a66.48,66.48,0,0,0,16.62-.6c4.67-.8,8.37-2.1,10.52-3.64a5.37,5.37,0,0,0,2-2.25,5.5,5.5,0,0,0,.25-1,2.17,2.17,0,0,1-.16,1.06,5.29,5.29,0,0,1-1.94,2.37c-2.16,1.63-5.88,3-10.58,3.84a64.94,64.94,0,0,1-16.72.71,49.12,49.12,0,0,1-9.77-1.73,23.22,23.22,0,0,1-4.88-2,9.85,9.85,0,0,1-2.17-1.66A3.87,3.87,0,0,1,107,65.19a4,4,0,0,1,1.16-2.59,9.61,9.61,0,0,1,2.18-1.66,22.8,22.8,0,0,1,4.88-2A49.62,49.62,0,0,1,125,57.21a65.39,65.39,0,0,1,16.72.71c4.7.85,8.42,2.21,10.58,3.84a5.29,5.29,0,0,1,1.94,2.37A2.17,2.17,0,0,1,154.36,65.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.73,
    y: 14.39,
    width: 5.98,
    height: 16.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.9,65.19c.09-.66,9.36-37.53,9.36-37.53,9.57-4.42,19.37-4.23,29.37,0L634,65.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 610.46,
    cy: 65.19,
    rx: 23.56,
    ry: 7.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,65.19a4.09,4.09,0,0,0-.25-1,5.3,5.3,0,0,0-2-2.24c-2.15-1.55-5.85-2.85-10.52-3.65a66.94,66.94,0,0,0-16.62-.6A49.88,49.88,0,0,0,595,59.43a21.89,21.89,0,0,0-4.77,2A9.28,9.28,0,0,0,588.18,63a2.95,2.95,0,0,0,0,4.46A9.06,9.06,0,0,0,590.24,69,22,22,0,0,0,595,71a50.11,50.11,0,0,0,9.66,1.75,66.44,66.44,0,0,0,16.62-.6c4.67-.8,8.37-2.1,10.52-3.64a5.37,5.37,0,0,0,2-2.25,4.62,4.62,0,0,0,.25-1,2.22,2.22,0,0,1-.15,1.06,5.4,5.4,0,0,1-2,2.37c-2.16,1.63-5.88,3-10.57,3.84a65,65,0,0,1-16.73.71,48.9,48.9,0,0,1-9.76-1.73,23,23,0,0,1-4.88-2,9.91,9.91,0,0,1-2.18-1.66,3.47,3.47,0,0,1,0-5.18A9.61,9.61,0,0,1,590,60.94a23.22,23.22,0,0,1,4.88-2,49.62,49.62,0,0,1,9.76-1.73,65.39,65.39,0,0,1,16.72.71c4.7.85,8.42,2.21,10.58,3.84a5.4,5.4,0,0,1,2,2.37A2.22,2.22,0,0,1,634,65.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.4,
    y: 14.39,
    width: 5.98,
    height: 16.87,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.82,456v1s16.69,6.88,16.83,10.06l-33.25-.49.61-11.06A19,19,0,0,0,606.82,456Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.39,466.58l.15-2.66,31.82,1.45s1.47.66,1.28,1.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.93,457.1c0,.16-.82.22-1.63.73s-1.24,1.19-1.39,1.12.11-1,1.09-1.6S607,457,606.93,457.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.39,458.59c0,.16-.67.43-1.23,1.11s-.73,1.4-.89,1.39-.26-.93.46-1.76S610.39,458.44,610.39,458.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.31,462.8c-.15,0-.36-.78.07-1.67s1.2-1.22,1.26-1.09-.41.61-.75,1.34S612.47,462.78,612.31,462.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583,446l14.16,4-3.54,8,3.67,20.32a2.31,2.31,0,0,1-1.6,2.64,2.34,2.34,0,0,1-2.38-.69c-3.13-3.5-14.56-16.45-14.28-18l.45-4.23a32.52,32.52,0,0,1,.94-3.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.31,481,579.2,460.75l-.08.92a2.53,2.53,0,0,0,.65,2.12c1.26,2,4.86,6.67,13.51,16.46a2.32,2.32,0,0,0,2,.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.06,471a5,5,0,0,1,4.75-1.76c0-.06-.25-.25-.77-.37a3.68,3.68,0,0,0-2,.16,3.47,3.47,0,0,0-1.63,1.2C591.08,470.67,591,471,591.06,471Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.39,474.08a19.53,19.53,0,0,1,2.07-.75,17.62,17.62,0,0,1,2.21-.08,2.65,2.65,0,0,0-2.31-.4C593,473.11,592.28,474,592.39,474.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.44,467a22.46,22.46,0,0,1,3.11-1.38,25,25,0,0,1,3.39-.45,5.23,5.23,0,0,0-3.53,0A5.07,5.07,0,0,0,588.44,467Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.37,462.29c.34,1.94.67,3.68.93,4.94a10,10,0,0,0,.51,2,10.88,10.88,0,0,0-.22-2.08c-.18-1.27-.46-3-.8-5-.29-1.63-.57-3.13-.8-4.3v0a16.8,16.8,0,0,0-.16-2.73,14.8,14.8,0,0,0-.17,2.73h0v0",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.9,324.58a43.21,43.21,0,0,1-.65-15.06c1.83-12.17,3-16.68,9.23-29.87L588,280l46.62-.37,1.82,2.8c4,10.8,6.75,17.24,7.88,25.14,1.3,9.09-1,22.26-6,35.56-10.9,28.71-17,51.68-17.41,57.86s-1.08,12.58-6.81,32.16c-4.19,14.3-7.28,22.85-7.28,22.85-4.35,2.45-9,3.11-13.16.73l-12.81-4.94s3.93-33.73,8.51-42.67c3.3-6.44,8.69-9.5,6.18-17.89S581.32,341.1,577.9,324.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.33,297.19l-.17.22-.49.68c-.44.61-1.06,1.5-1.87,2.65l-7,10.07,0,0v0c.34,3.77.47,8.14.7,13s.49,10.23.76,16,.63,11.92,1,18.37.71,13.19,1.35,20.13c.68,5.77,1.27,11.44.78,16.89a40.3,40.3,0,0,1-.55,4,26.75,26.75,0,0,1-1,3.85c-.91,2.45-2,4.82-3,7.12-4.07,9.22-7.88,17.46-11.06,24.38L597.23,451c-.88,1.93-1.57,3.43-2.05,4.46l-.52,1.17c-.12.26-.17.4-.17.4s.08-.13.21-.38.32-.66.56-1.15c.49-1,1.2-2.52,2.12-4.43,1.82-3.87,4.45-9.45,7.68-16.33s7.06-15.14,11.15-24.35c1-2.31,2.08-4.66,3-7.15a28.16,28.16,0,0,0,1-3.9c.26-1.33.43-2.69.56-4.06.5-5.5-.1-11.2-.77-17-.64-6.91-1-13.66-1.37-20.11s-.68-12.6-1-18.36-.56-11.12-.81-16-.41-9.25-.78-13l0,.08,6.9-10.13c.79-1.17,1.39-2.07,1.82-2.69l.45-.7A1.14,1.14,0,0,0,625.33,297.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.54,237.59a2.24,2.24,0,0,0-1.07-1.77c-9.48-6.28-16.63-20.19-17.35-32l-.06-2h0c-.54-16.84-3-37.26-5.25-42.71-4.11-10.05-18-11-18-11C589.27,146.77,586,161,584.1,173.92c-1.16,8-5.63,36.79-5.63,36.79l3.4,1.31a41.8,41.8,0,0,0,24.74,25.87c3.4,1.29,6.29,1.8,7.64.7a46.65,46.65,0,0,0,19.46,11.81,24,24,0,0,0,9.22,1.22c2-.18,4.15-.85,5.35-2.48a4.64,4.64,0,0,0-4-7.39C645,239.48,649.62,240.15,649.54,237.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.22,153.32l-1.16-1.1-12.5,5a3.5,3.5,0,0,0-3.29,3.38l.11,40.72a11.38,11.38,0,0,0,2.21,7.36l1.75,2.32a9.22,9.22,0,0,0,15.41-1,4.48,4.48,0,0,0,.44-1.05,7.28,7.28,0,0,0,.18-.91c.38-3.28.4-6.12.4-6.12.22-3.6.29-5.07.29-5s7.66-.88,9.73-10.71c1-4.88.83-11.61.55-18.22C623.94,158.85,617.58,153.31,610.22,153.32Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.22,174.22a1.27,1.27,0,0,1-1.29,1.22,1.22,1.22,0,0,1-1.25-1.21A1.28,1.28,0,0,1,607,173,1.22,1.22,0,0,1,608.22,174.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.73,174.22a1.28,1.28,0,0,1-1.29,1.22,1.22,1.22,0,0,1-1.25-1.21,1.28,1.28,0,0,1,1.29-1.23A1.22,1.22,0,0,1,620.73,174.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623,170.62c-.17.16-1.09-.6-2.46-.67s-2.41.57-2.54.4.1-.37.55-.67a3.6,3.6,0,0,1,2-.52,3.4,3.4,0,0,1,2,.74C623,170.25,623.11,170.55,623,170.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.15,170.76c-.18.14-1-.71-2.37-.91s-2.45.32-2.57.13.14-.36.62-.61a3.51,3.51,0,0,1,2.09-.3,3.33,3.33,0,0,1,1.86.93C609.15,170.38,609.24,170.7,609.15,170.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.93,180.72a8.61,8.61,0,0,1,2.24-.29c.35,0,.69-.07.76-.31a1.91,1.91,0,0,0-.18-1.05c-.29-.86-.59-1.76-.9-2.71-1.25-3.85-2.13-7-2-7.07a46.91,46.91,0,0,1,2.53,6.9c.3.95.58,1.86.86,2.72a2.07,2.07,0,0,1,.11,1.38.87.87,0,0,1-.6.48,2.7,2.7,0,0,1-.6.06A9.71,9.71,0,0,1,613.93,180.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.06,196.94a25.22,25.22,0,0,1-13.09-4.2s3,7,13,6.59Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.19,184a2.48,2.48,0,0,0-2.16-1,2.25,2.25,0,0,0-1.6.75,1.45,1.45,0,0,0-.19,1.63,1.67,1.67,0,0,0,1.77.54,5.23,5.23,0,0,0,1.8-1,1.49,1.49,0,0,0,.41-.38.45.45,0,0,0,0-.51",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.86,181.46c.22,0,.15,1.48,1.37,2.6s2.8,1,2.81,1.24-.37.27-1,.26a3.68,3.68,0,0,1-2.35-1,3.21,3.21,0,0,1-1-2.17C609.58,181.81,609.76,181.45,609.86,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.46,165.43c-.19.35-1.51,0-3.13-.08s-3,.18-3.12-.18c-.07-.17.2-.48.77-.76a5.45,5.45,0,0,1,4.77.2C610.3,164.94,610.55,165.27,610.46,165.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.83,164.75c-.25.3-1.18-.07-2.31-.14s-2.1.1-2.31-.24c-.09-.16.08-.46.51-.74a3.25,3.25,0,0,1,1.91-.41,3.18,3.18,0,0,1,1.82.72C622.83,164.28,623,164.6,622.83,164.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.52,178s7,2.18,11-15.1c1.36-5.91,6.84-10.7,6.84-10.7l-2.22-.67s-13.81,3.89-14,4.07-3.49,7.14-3.49,7.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.25,177.37c0-.73-.74-2.52-1.46-2.67-1.93-.4-5.44-.42-5.72,4.52-.39,6.75,6.47,5.75,6.49,5.55S595.12,179.92,595.25,177.37Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.65,182.1s-.13.07-.33.15a1.17,1.17,0,0,1-.88,0,2.93,2.93,0,0,1-1.2-2.69,3.85,3.85,0,0,1,.43-1.66,1.34,1.34,0,0,1,.93-.85.59.59,0,0,1,.68.36c.08.19,0,.32.06.34s.15-.11.12-.39a.74.74,0,0,0-.25-.44.89.89,0,0,0-.64-.21,1.64,1.64,0,0,0-1.28,1,4,4,0,0,0-.52,1.86c0,1.36.59,2.68,1.55,3a1.31,1.31,0,0,0,1.09-.11C592.63,182.26,592.67,182.11,592.65,182.1Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589,203.52a1.76,1.76,0,0,1-.07-.32c0-.24-.1-.56-.17-1-.15-.87-.35-2.1-.61-3.67l.16,0,.11.79v0l.14.3-.17.06a65,65,0,0,1-2.17-10.86,67.41,67.41,0,0,1-.41-7,32,32,0,0,1,.67-7.7,12.1,12.1,0,0,1,1.23-3.07,17,17,0,0,1,1.86-2.6c1.38-1.59,2.86-2.95,4.21-4.3l7.25-7.14c2-2,3.73-3.64,4.9-4.78l1.35-1.3.35-.33.13-.1a.78.78,0,0,1-.11.13l-.33.35-1.3,1.33-4.84,4.86-7.2,7.18c-1.35,1.36-2.83,2.73-4.18,4.3a13.32,13.32,0,0,0-3,5.54,32.22,32.22,0,0,0-.67,7.63,64.38,64.38,0,0,0,.39,7,67.92,67.92,0,0,0,2.06,10.85l-.17.06-.13-.31h0l-.1-.8.16,0c.23,1.58.41,2.81.53,3.68.06.41.1.73.13,1A1.38,1.38,0,0,1,589,203.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.54,170.78a1.07,1.07,0,0,1,.12-.29l.39-.79c.34-.69.88-1.66,1.59-2.84s1.61-2.55,2.67-4,2.33-3,3.73-4.6,2.83-3,4.17-4.19,2.62-2.26,3.72-3.08,2-1.47,2.66-1.89l.74-.47a1.07,1.07,0,0,1,.27-.15s-.07.08-.23.2l-.72.52c-.62.44-1.51,1.11-2.59,2s-2.32,1.9-3.66,3.12-2.73,2.64-4.13,4.19-2.64,3.11-3.73,4.56-2,2.8-2.71,4-1.3,2.11-1.67,2.78l-.45.76A1.07,1.07,0,0,1,584.54,170.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.36,223.54c0-.24-10.09-20-10.09-20l-3.21-4.59-.06,2.19-1.47,8.34-19.26-11.87s-1.57,3-1.81,3.38l11.72,36.55,6.4,37.7,3.71,5.93,20.13-1.49-1.16-27.12,1.35-8.3S627.36,223.77,627.36,223.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.05,205.87l-12.11,4.55,12.22,54.43s-2.54,8.88-4.9,14.8c-8.93,22.46-10.69,35.77-10.69,35.77L607,318s9.57-42.67,8.94-52.32-2.05-23.06-5.75-32.57-18.53-32.85-18.53-32.85Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.61,199.23l5.49,4.53L635.18,206s7.13,25.84,5.81,36,.52,27.75.52,27.75l8.21,46.43-13.14.56s-4.15-50.12-4.4-49.59c0,0-.7-24.07-2.28-31.2S617,206,617,206Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.18,263.55s6.07-2.77,6.07-8.18-3.69-13.07-4.48-16S637,205.61,635.18,206l-1.85.39,9.5,41.71L628.78,252l6,15.61Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.66,250.08l2.67-8.63.45-5.87,6.27-4.17s1.69.19,1.16,1.5-3.06,3.65-3.06,3.65l-1.5,4.18,2.44-4.25,3.56-1.76,3.52.26s.65,1.57-1,1.63h-1.76l-2.67,2.15-1.67,4,2.52-3.91,3.71-1.33,2.35.61s.65,1-.52,1.17-2,.13-2,.13L648,240.74l-1.89,4,3.32-2.74,4.31-.52s.71,1-.4,1.43a36.08,36.08,0,0,0-3.32,1.57l-2.41,2.93Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.44,275.61a1.3,1.3,0,0,1-.06-.2l-.15-.57c-.14-.53-.32-1.28-.56-2.24-.49-2-1.18-4.76-2-8.21s-1.88-7.59-3.06-12.16c-.59-2.29-1.22-4.69-1.9-7.16-.34-1.24-.7-2.5-1.08-3.77-.19-.63-.4-1.26-.61-1.9a17.39,17.39,0,0,0-.77-1.86c-2.22-4.45-4.49-8.65-6.54-12.53l-5.59-10.43,0-.08.07-.06q.61-.56,1.23-1.05a4.91,4.91,0,0,1,.63-.47.23.23,0,0,1,.1,0l0,0s0,0,0,0l0,0a.1.1,0,0,0,0,.11l0,0h-.53c-1,0-1.9,0-2.76,0h-.06l0-.06c-.87-2.23-1.55-4-2-5.23-.22-.6-.39-1.06-.52-1.39l-.13-.36a.63.63,0,0,1,0-.13s0,0,.06.12l.16.35c.13.33.32.79.56,1.37.5,1.23,1.21,3,2.1,5.2l-.08,0c.86,0,1.78-.05,2.76-.05H594a2.06,2.06,0,0,1,.21,0h0l0,0a.13.13,0,0,1,0,.11l0,.06-.06,0,0,0-.07,0c-.2.13-.4.3-.6.46-.41.33-.81.68-1.22,1.05l0-.14,5.63,10.41c2.07,3.87,4.34,8.06,6.56,12.53a14.22,14.22,0,0,1,.79,1.89c.21.64.42,1.28.61,1.91q.57,1.92,1.08,3.78c.68,2.48,1.3,4.88,1.88,7.16,1.17,4.58,2.17,8.72,3,12.19l1.93,8.24.51,2.24.12.59C614.44,275.54,614.45,275.61,614.44,275.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.61,246.3a1.94,1.94,0,0,1,0-.47c0-.33,0-.77.07-1.32q0-.44.06-1v-1.14c0-.82,0-1.75-.06-2.78a58,58,0,0,0-3.12-15.71,54.34,54.34,0,0,0-2.54-6.24h0a54.66,54.66,0,0,0-2.93-5.7c-1-1.68-1.86-3.14-2.6-4.35s-1.34-2.14-1.77-2.82l-.47-.76a2.59,2.59,0,0,1-.15-.27,1.18,1.18,0,0,1,.19.24c.14.19.3.43.51.73.44.64,1.07,1.58,1.84,2.78s1.68,2.65,2.67,4.32a54.82,54.82,0,0,1,3,5.72h0a51.32,51.32,0,0,1,2.57,6.28,55.61,55.61,0,0,1,3,15.8c.07,1,0,2,0,2.79,0,.41,0,.79,0,1.15s-.06.66-.09.95c0,.56-.1,1-.13,1.33A2.9,2.9,0,0,1,633.61,246.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.63,263.32a1.89,1.89,0,0,1-.37.11l-1.09.25-4.09.89-14.3,3-.12,0,0-.12c-1.21-3.55-2.53-7.44-3.91-11.52l-1.43-4.24-.06-.16.17,0L640.15,249l4.63-1.08,2.09-.49a9.92,9.92,0,0,1,2-.33,7.37,7.37,0,0,1,3.32.67,8.72,8.72,0,0,1,2.13,1.39,7.57,7.57,0,0,1,1.07,1.19l.23.35a.64.64,0,0,1,.07.12,10.08,10.08,0,0,0-1.44-1.57,8.25,8.25,0,0,0-2.12-1.33,7.15,7.15,0,0,0-3.25-.62,9.09,9.09,0,0,0-1.91.35l-2.09.5-4.63,1.11-10.75,2.57.11-.2,1.43,4.24,3.89,11.53-.17-.09,14.33-2.93,4.1-.82,1.1-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "584.71 284.03 604.52 285.85 601.11 291.91 580.24 289.88 584.71 284.03",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.71,284l-.07.11-.22.32-.87,1.17-3.23,4.31-.07-.17,20.14,1.92.74.07-.15.08,3.41-6.06.12.22-14.17-1.37-4.13-.42-1.11-.12a2.21,2.21,0,0,1-.39-.06h.37l1.1.08,4.11.33,14.25,1.25.22,0-.11.2-3.4,6.07,0,.09h-.1l-.74-.07-20.13-2-.19,0,.12-.15,3.33-4.27.9-1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "638.05 286.06 641.15 291.91 647.81 290.55 644.28 285.16 638.05 286.06",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.05,286.06l.41-.08,1.24-.21c1.08-.18,2.65-.45,4.56-.74h.08l0,.07,3.55,5.38.12.19-.22,0-.34.07-6.32,1.28h-.1L641,292c-.93-1.79-1.68-3.29-2.2-4.32l-.59-1.19a3.76,3.76,0,0,1-.19-.41,2.77,2.77,0,0,1,.26.44l.67,1.19c.57,1,1.37,2.44,2.29,4.16l-.15-.07,6.32-1.31.34-.07-.1.24-3.51-5.4.13.05c-1.84.26-3.38.44-4.48.58l-1.29.15A3.76,3.76,0,0,1,638.05,286.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "582.66 290.11 581.84 291.91 602.42 293.8 603.96 286.86 601.11 291.91 582.66 290.11"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M586.9,263.4s3.23,6.77,7.43,8.75c5.73,2.71,20.07.94,20.07.94l0-4.11-16.62.95Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M576.7,210.1s-5.8.39-5.94,15.57,17.69,40.66,20.73,43.16,6.5,4.2,15.65,2.84c11.47-1.7,19.46-3.23,19.46-3.23L625,254.58l-20.46-.93-16.63-34.18S582.38,209.44,576.7,210.1Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M630,260.4a18.53,18.53,0,0,0-7.19-1l-9.69,0a24.5,24.5,0,0,0-6.23.52,8.27,8.27,0,0,0-5.07,3.41l-5.06,4.18a33.52,33.52,0,0,0,19.52-1.14,23.85,23.85,0,0,1,4.76-1.55c4.37-.69,8.8,1.85,13.15,1C634.2,263.43,632.25,261.34,630,260.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M597.19,246.3a44.46,44.46,0,0,0,5.81,1.88,36.11,36.11,0,0,1,7.2,2.29,48.78,48.78,0,0,1,4.8,2.21l3,10.63a21.76,21.76,0,0,1-10.8,3c-5.72-.16-10.79,1.69-11.53,1.17s-.82-1.42,0-1.83a28.09,28.09,0,0,1,4.29-.9l3-1.22s-10.23.9-11,.49-1.64-1-1.31-1.88a1.27,1.27,0,0,1,1.14-.9s-2.21.08-2.12-.82a2.82,2.82,0,0,1,1.22-1.88c.33-.17,4.62-1.91,4.62-1.91l5.52-1.1-5.3-.21-4.63,1.29s-1.85.21-1.44-1.34,6.06-3.28,6.06-3.28l7.2-.49s-5.56-.82-6.14-2.53A2.65,2.65,0,0,1,597.19,246.3Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "615 252.68 615.35 252.68 629.4 252.06 633.61 264.32 618.05 263.31 615 252.68",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.74,259.65a11.87,11.87,0,0,1-1.72.14c-1.06.06-2.52.18-4.12.43s-3,.55-4.06.81a13.05,13.05,0,0,1-1.68.38,7.26,7.26,0,0,1,1.62-.59,30.32,30.32,0,0,1,8.23-1.25A8.82,8.82,0,0,1,602.74,259.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.22,227.21a4.09,4.09,0,0,1-.46-.68c-.29-.44-.69-1.08-1.22-1.86a65.8,65.8,0,0,0-4.35-5.88,33.43,33.43,0,0,0-5.18-5.14,27.25,27.25,0,0,0-2.54-1.64,3.88,3.88,0,0,1,.76.31,7.53,7.53,0,0,1,.85.46,9.6,9.6,0,0,1,1.06.7,29.64,29.64,0,0,1,5.29,5.11,53.67,53.67,0,0,1,4.3,6c.5.8.88,1.46,1.13,1.92A4.17,4.17,0,0,1,592.22,227.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.32,247.43a3.85,3.85,0,0,1-.32-.68c-.2-.51-.46-1.14-.77-1.9-.64-1.59-1.54-3.8-2.59-6.21s-2-4.57-2.78-6.13l-.86-1.85a3.37,3.37,0,0,1-.28-.69,4,4,0,0,1,.39.64c.23.42.56,1,.95,1.81.78,1.54,1.81,3.69,2.86,6.1s1.93,4.64,2.52,6.26c.29.81.53,1.47.67,1.92A3.84,3.84,0,0,1,601.32,247.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.55,211.72l-.47-.25.07-.05c.37,1.33,1.43,5.66,2.63,10.8.73,3.13,1.37,6,1.82,8,.21,1,.39,1.82.52,2.45a6.2,6.2,0,0,1,.15.9,4.74,4.74,0,0,1-.27-.88c-.16-.62-.36-1.44-.61-2.42-.51-2-1.18-4.87-1.91-8-1.2-5.14-2.17-9.49-2.42-10.85l0-.11.09.06C634.43,211.6,634.56,211.7,634.55,211.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616,270.22a1.49,1.49,0,0,1-.37.12l-1.06.29c-.92.24-2.27.55-3.95.86a48,48,0,0,1-6,.72,27.44,27.44,0,0,1-7.33-.49,14.43,14.43,0,0,1-3.61-1.26,12.18,12.18,0,0,1-1.56-.94,11.37,11.37,0,0,1-1.29-1.19,45.92,45.92,0,0,1-3.7-4.72c-1-1.39-1.74-2.55-2.26-3.35-.23-.38-.43-.69-.58-.93a3.11,3.11,0,0,1-.18-.34,1.71,1.71,0,0,1,.24.3l.62.9c.55.78,1.33,1.92,2.33,3.29a50.45,50.45,0,0,0,3.74,4.65,10.52,10.52,0,0,0,1.25,1.15,11.65,11.65,0,0,0,1.53.91,14.38,14.38,0,0,0,3.54,1.23,28.09,28.09,0,0,0,7.25.51,51.38,51.38,0,0,0,5.93-.65c1.67-.28,3-.56,3.95-.77l1.08-.23A2.89,2.89,0,0,1,616,270.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "588.61 207.28 590.18 214.73 591.46 213.94 590.72 215.71 606.76 244.8 604.68 238.16 592.19 214.53 594.17 212.95 590.85 212.95 588.61 207.28"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 592.9,
    cy: 185.82,
    r: 2.87,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.87,158.89A14.66,14.66,0,0,1,401,171.45c-.24,2.27-.94,4.85.49,6.63s4.29,1.79,5.65,3.6c1.59,2.13.12,5.19.64,7.8a5.28,5.28,0,0,0,5.49,4.08,20.57,20.57,0,0,1-10.31,4.13c-.92-1.25-1.84-2.49-2.75-3.74a3.78,3.78,0,0,1-.39,4.63,8.64,8.64,0,0,1-4.33,2.4,26.07,26.07,0,0,1-22.75-4.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,177.79a51.7,51.7,0,0,0,2.05-5.1c.94-3.84-.82-8.24,1.15-11.66,1.4-2.43,4.28-3.56,7-4.31s5.61-1.37,7.67-3.29c1.51-1.4,2.4-3.36,3.9-4.77,2.15-2,5.25-2.62,8.18-2.72a17.63,17.63,0,0,1,8.79,1.68,9.65,9.65,0,0,1,5.24,6.95c.19,1.46,0,3,.39,4.39s1.63,2.77,2.34,4.23a7.74,7.74,0,0,1-2.2,9.21l-21.41,26.1c-4.39,1.52-14.85-.76-18.11-4.06S350.94,182.16,352.51,177.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.55,169c-.68-6.08-5.08-13.37-11.13-12.44l-18.75,5.72a3.58,3.58,0,0,0-3,3.78l4.23,44s-1.4,1.09-2.29.73a.25.25,0,0,0-.31.36c2.14,3.31,12.27,17.76,23.24,13.75,2.45-.9,0-8.61.35-11.44l-.11-7.23c-.14-3.7-.21-5.22-.21-5.18s7.73-1.67,8.85-11.92C398,184,397.31,175.75,396.55,169Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,178.26a1.31,1.31,0,0,1-1.2,1.37,1.25,1.25,0,0,1-1.4-1.11,1.31,1.31,0,0,1,1.19-1.38A1.26,1.26,0,0,1,394,178.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,178.68a1.3,1.3,0,0,1-1.19,1.38,1.25,1.25,0,0,1-1.4-1.11,1.31,1.31,0,0,1,1.19-1.38A1.24,1.24,0,0,1,381,178.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.58,174c-.15.23-1.34-.57-2.86-.39s-2.52,1.19-2.71,1,0-.49.46-1a3.54,3.54,0,0,1,2.15-1.06,3.47,3.47,0,0,1,2.31.58C395.45,173.53,395.66,173.9,395.58,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.94,174.75c-.19.21-1.35-.69-3-.67s-2.81.92-3,.7.09-.47.61-.89a4,4,0,0,1,2.39-.82,3.85,3.85,0,0,1,2.38.79C381.85,174.27,382,174.65,381.94,174.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.78,184.49A9.3,9.3,0,0,1,389,184c.35-.06.69-.15.74-.39a1.86,1.86,0,0,0-.29-1.05l-1.2-2.68c-1.66-3.81-2.88-7-2.72-7s1.62,3,3.28,6.78c.4.94.79,1.84,1.15,2.7a2,2,0,0,1,.25,1.4.87.87,0,0,1-.56.55,2.56,2.56,0,0,1-.6.11A9,9,0,0,1,386.78,184.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.55,201.05a25.92,25.92,0,0,1-13.79-3s3.76,7,13.9,5.52Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.39,188.45a2.2,2.2,0,0,1,.74-.83,1.82,1.82,0,0,1,1.22-.09,2.86,2.86,0,0,1,1.56.85,1.68,1.68,0,0,1,.35,1.69h0c-.17.58-1.05.88-1.65,1a2.7,2.7,0,0,1-1.74-.42,1.55,1.55,0,0,1-.86-1.18A2,2,0,0,1,382.39,188.45Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.73,186.49c.23,0,.31,1.5,1.66,2.52s3,.77,3,1-.34.32-1,.37a3.85,3.85,0,0,1-2.49-.74,3.33,3.33,0,0,1-1.3-2.11C382.48,186.87,382.63,186.49,382.73,186.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,169.26c-.12.39-1.53.28-3.17.55s-2.94.8-3.18.46c-.1-.15.11-.52.63-.92a5.62,5.62,0,0,1,4.84-.77C381.7,168.79,382,169.08,382,169.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86,168.86c-.26.33-1.38,0-2.71.1s-2.45.34-2.72,0c-.12-.15,0-.48.52-.81a4.18,4.18,0,0,1,2.18-.62,4.11,4.11,0,0,1,2.19.53C394.81,168.38,395,168.7,394.86,168.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.52,163.62a8.32,8.32,0,0,1,4.31-2.68,93.48,93.48,0,0,1,21.66-4.87c.87,1.54,0,3.57-1.44,4.63a16.92,16.92,0,0,1-4.88,2c-1.67.57-3.39,1.48-4.12,3.09s-.22,3.78-.9,5.53c-1.18,3-5.45,3.87-6.62,6.88-.88,2.28.39,4.77.65,7.2a8.73,8.73,0,0,1-8.85,9.7q-.39-13.11-.77-26.21C361.5,167.08,361.49,165.12,362.52,163.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33,185.16c1.41-1.2,3.17-2.21,3.77-4,.87-2.56-1.11-5.64.28-7.94,1.28-2.1,4.85-1.9,6-4,.93-1.68,0-3.21.34-4.7a4.09,4.09,0,0,1,4.06-2.52l11.42,17.6c.94,5.82,2,8.94.63,12.29a27,27,0,0,0-2,5.58c-.32,1.95.12,4.19,1.69,5.39-7.14.36-13.71-3.56-19.78-7.34l-6.42-4a4.85,4.85,0,0,1-1.75-1.55C341.7,188.36,342.91,186.36,344.33,185.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.66,193.76a2.9,2.9,0,0,0,.75.17,6.43,6.43,0,0,0,2.22-.09,6.87,6.87,0,0,0,3.15-1.58,6.76,6.76,0,0,0,2.15-4.11,7.07,7.07,0,0,0-.15-2.73,11.1,11.1,0,0,0-1.25-2.69,10.68,10.68,0,0,1-1.29-2.78,3.55,3.55,0,0,1,.47-3c.67-.85,1.88-1,3-1.45a3.25,3.25,0,0,0,1.55-1.08,3.15,3.15,0,0,0,.54-1.85,20.77,20.77,0,0,0-.7-3.74,4,4,0,0,1,0-1.82,2.53,2.53,0,0,1,1.07-1.41,7,7,0,0,1,3.63-.86,7.83,7.83,0,0,0,3.7-1,6.93,6.93,0,0,0,2.59-2.65,11.57,11.57,0,0,0,1-3.39,15.74,15.74,0,0,1,.79-3.18,7.11,7.11,0,0,1,1.75-2.48,8,8,0,0,1,9.37-1,9.92,9.92,0,0,1,2.68,2.16,12.29,12.29,0,0,1,1.63,2.48s0-.06-.06-.19-.12-.3-.23-.53a9.78,9.78,0,0,0-3.91-4.13,8.36,8.36,0,0,0-4.51-1.13,8.47,8.47,0,0,0-5.21,2.13,7.51,7.51,0,0,0-1.85,2.59,16.84,16.84,0,0,0-.83,3.25,11.14,11.14,0,0,1-1,3.27,6.58,6.58,0,0,1-2.45,2.49,7.35,7.35,0,0,1-3.52.92,7.48,7.48,0,0,0-3.84.92,3,3,0,0,0-1.23,1.65,4.37,4.37,0,0,0-.05,2,21.23,21.23,0,0,1,.71,3.66,2.8,2.8,0,0,1-.47,1.62,2.77,2.77,0,0,1-1.36,1c-.54.21-1.12.35-1.68.57a3.36,3.36,0,0,0-1.49,1,3.87,3.87,0,0,0-.52,3.33,10.89,10.89,0,0,0,1.34,2.88,10.94,10.94,0,0,1,1.24,2.59,6.65,6.65,0,0,1,.17,2.61,6.56,6.56,0,0,1-2,4,6.78,6.78,0,0,1-3,1.59A7.49,7.49,0,0,1,350.66,193.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.44,187.6a2.77,2.77,0,0,1-.07,1.86,2.49,2.49,0,0,1-1.53,1.46,2.56,2.56,0,0,1-2.59-.79,2.35,2.35,0,0,1-.57-1.5,5,5,0,0,1,.32-1.8c.42-1.19,1.22-2.48,1.15-4.06a5.74,5.74,0,0,0-2-4.18,6.93,6.93,0,0,0-2.19-1.23,9.87,9.87,0,0,0-2.52-.44,12.92,12.92,0,0,1-2.46-.32,3.29,3.29,0,0,1-1.88-1.25,4,4,0,0,1-.63-2.13,7.67,7.67,0,0,1,.24-2.19,16.69,16.69,0,0,0,.76-4.15,6.21,6.21,0,0,0-1.18-3.49,8,8,0,0,0-2.26-2,14.68,14.68,0,0,1-1.82-1.33,4.59,4.59,0,0,1-1.12-1.54s0,0,0,.13a2.75,2.75,0,0,0,.13.35,3.83,3.83,0,0,0,.86,1.17,13.82,13.82,0,0,0,1.8,1.41,8.06,8.06,0,0,1,2.15,2,6,6,0,0,1,1.07,3.33,16.74,16.74,0,0,1-.78,4.06,8.17,8.17,0,0,0-.27,2.29,4.45,4.45,0,0,0,.69,2.34,3.66,3.66,0,0,0,2.11,1.41,13.63,13.63,0,0,0,2.53.35,9.58,9.58,0,0,1,2.43.41,6.51,6.51,0,0,1,2.06,1.15,5.41,5.41,0,0,1,1.93,3.88c.08,1.44-.67,2.68-1.09,3.94a5.13,5.13,0,0,0-.32,1.92,2.64,2.64,0,0,0,.67,1.69,2.79,2.79,0,0,0,2.88.81,2.59,2.59,0,0,0,1.61-1.62,2.62,2.62,0,0,0,.11-1.45A1.45,1.45,0,0,0,416.44,187.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,151.45s-.42.49-1.34,1.68-3.28,2.26-4.19,2.62-4.49,1.21-6,1.73a11.16,11.16,0,0,0-3.79,2.55c-1.45,1.24-1.61,2.66-2,3.86s.15,2.53.12,3.63a5.16,5.16,0,0,1-1,2.67c-.62,1.15-3.51,1.65-4.8,2.45s-1.06,2.38-1.12,3.1a20.65,20.65,0,0,0,.37,2.85,7,7,0,0,1,0,1.88,4.45,4.45,0,0,1-.8,1.89,12.34,12.34,0,0,1-2,1.89l-1.26,1.05c-1.41,1.19-2.51,3.07-1.6,4.68a4.85,4.85,0,0,0,1.75,1.55h0s2.88-1.16,5-5.45c1.14-2.35,1.65-4.87,1.69-8.94,0-3.56,3.92-3.38,5.3-6,2.46-4.69.17-6.9,3.29-9.17,3.63-2.64,5.09.36,11.24-5.65,4.62-4.52,5.13-6.79,10.81-8.68,5.91-2,12.31,2,12.31,2a11.13,11.13,0,0,0-2.73-2,17.63,17.63,0,0,0-8.79-1.68c-2.93.1-6,.71-8.18,2.72A11.43,11.43,0,0,0,373,150.1l-.22.29",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.89,180.07c1.92,2.49,4.79,2.69,4.79,6.43s3.36,8.62,3.36,8.62v1.34a20.46,20.46,0,0,0,5.19-2.89,5.28,5.28,0,0,1-5.49-4.07c-.52-2.61.95-5.68-.64-7.81-1.36-1.81-4.24-1.84-5.65-3.6s-.73-4.36-.49-6.63a14.72,14.72,0,0,0-3.24-10.69.43.43,0,0,1,0-.07c.34.28.74.56,1.17.86a8.22,8.22,0,0,1,2.15,2,6,6,0,0,1,1.07,3.33,16.56,16.56,0,0,1-.78,4.06,8.22,8.22,0,0,0-.27,2.29,4.45,4.45,0,0,0,.69,2.34,3.73,3.73,0,0,0,2.11,1.42,13.61,13.61,0,0,0,2.53.34,10,10,0,0,1,2.43.41,6.51,6.51,0,0,1,2.06,1.15,5.42,5.42,0,0,1,1.93,3.88c.08,1.45-.67,2.68-1.09,3.94a5.13,5.13,0,0,0-.32,1.92,2.64,2.64,0,0,0,.67,1.69,2.82,2.82,0,0,0,2.88.82,2.73,2.73,0,0,0,1.72-3.08,1.45,1.45,0,0,0-.19-.47,2.77,2.77,0,0,1-.07,1.86,2.47,2.47,0,0,1-1.53,1.46,2.57,2.57,0,0,1-2.59-.78,2.4,2.4,0,0,1-.57-1.51,5.07,5.07,0,0,1,.32-1.8c.42-1.19,1.22-2.48,1.15-4.06a5.74,5.74,0,0,0-2-4.18,6.93,6.93,0,0,0-2.19-1.23,9.86,9.86,0,0,0-2.52-.43,13.77,13.77,0,0,1-2.46-.33,3.29,3.29,0,0,1-1.88-1.25,4,4,0,0,1-.63-2.12,8.12,8.12,0,0,1,.24-2.2,16.7,16.7,0,0,0,.76-4.14,6.24,6.24,0,0,0-1.18-3.5,8.26,8.26,0,0,0-2.26-2,17.24,17.24,0,0,1-1.55-1.11,6.75,6.75,0,0,1-.57-1.29c-.42-1.41-.2-2.93-.39-4.39a8.81,8.81,0,0,0-2.51-4.91c1.64,3.47,2.67,7.48,2.07,10.49-.32,1.64,2.66,3.13,3,7.37S398.93,178.81,399.89,180.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,154.88s-.06-.56-.37-1.52a8.34,8.34,0,0,0-2.28-3.52,15.12,15.12,0,0,0-5.49-3,15.82,15.82,0,0,0-7.6-.64,13.87,13.87,0,0,0-6.88,3.23A11.93,11.93,0,0,0,371.7,152a8.92,8.92,0,0,1-2,2.28,11,11,0,0,1-3.94,1.84,10,10,0,0,1-1.16.22c-.27,0-.41,0-.41,0s.55-.13,1.51-.44a11.61,11.61,0,0,0,3.77-1.92,8.55,8.55,0,0,0,1.85-2.24,12.71,12.71,0,0,1,2.23-2.66,14.25,14.25,0,0,1,7.11-3.39,16.17,16.17,0,0,1,7.85.7,15.28,15.28,0,0,1,5.59,3.2,8,8,0,0,1,2.21,3.73,6.59,6.59,0,0,1,.2,1.17C396.53,154.74,396.52,154.88,396.5,154.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,190.37s-.07-.1-.17-.31a4.12,4.12,0,0,1-.27-1,17.14,17.14,0,0,1,0-3.64,8.87,8.87,0,0,0-.17-2.43,3.6,3.6,0,0,0-1.58-2.12,26.35,26.35,0,0,0-2.77-1.46,5.4,5.4,0,0,1-2.64-2.31,5.87,5.87,0,0,1-.18-3.5,18.84,18.84,0,0,0,.43-3.11,14.25,14.25,0,0,0-.8-5.2,19.06,19.06,0,0,0-2.32-4.31s.1.06.26.23a7,7,0,0,1,.64.76,12.93,12.93,0,0,1,1.76,3.19,14.1,14.1,0,0,1,.94,5.34,18.56,18.56,0,0,1-.4,3.18,5.44,5.44,0,0,0,.14,3.2,5,5,0,0,0,2.4,2.08,23.74,23.74,0,0,1,2.82,1.52,4,4,0,0,1,1.72,2.41,9,9,0,0,1,.12,2.55,21,21,0,0,0-.15,3.59C407.86,189.91,408.06,190.35,408,190.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.2,156.32a18.64,18.64,0,0,0-4.47,1.43A9.81,9.81,0,0,0,356,161a7.68,7.68,0,0,0-1.11,2.71,16.79,16.79,0,0,0-.11,3.21,5.35,5.35,0,0,1-.82,3.26,5.14,5.14,0,0,1-2.73,1.57,5.9,5.9,0,0,0-2.36,1.13,3.84,3.84,0,0,0-1.05,2,8,8,0,0,0,.19,3.37,6.51,6.51,0,0,1,.26,1.25,5.27,5.27,0,0,1-.46-1.19,7.7,7.7,0,0,1-.35-3.5,4.11,4.11,0,0,1,1.11-2.22,6.15,6.15,0,0,1,2.52-1.28,4.72,4.72,0,0,0,2.46-1.41,4.91,4.91,0,0,0,.71-3,16.58,16.58,0,0,1,.13-3.3,8,8,0,0,1,1.21-2.87,9.89,9.89,0,0,1,4-3.35,11.43,11.43,0,0,1,3.35-1A4.77,4.77,0,0,1,364.2,156.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.52,185.33a5,5,0,0,1-.11-1.16c0-.86-.09-1.91-.15-3.16-.14-2.66-.36-6.34-.8-10.38a20.06,20.06,0,0,0-3.3-9.65,16.34,16.34,0,0,0-3-3,4.16,4.16,0,0,1,1,.58,10.12,10.12,0,0,1,2.3,2.21,19.33,19.33,0,0,1,3.52,9.81c.44,4.06.61,7.75.65,10.43,0,1.33,0,2.42,0,3.16A4.83,4.83,0,0,1,397.52,185.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.94 432.29 364.35 459.89 376.46 458.4 378.04 431.3 361.94 432.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.66,452.94s-8.29,6.64-12.66,1.47l-1,2.66L359,475.87a2.49,2.49,0,0,0,1.49,2.91,2.32,2.32,0,0,0,2.47-.61c3.38-3.6,15.72-16.9,15.52-18.61l-.24-4.55a2.32,2.32,0,0,0-1.53-2.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.87,478.89,378.37,458l0,1a2.86,2.86,0,0,1-.78,2.24c-1.4,2.12-5.31,6.91-14.65,17a2.36,2.36,0,0,1-2.11.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,468.38c-.13.07-.7-1.14-2.09-1.74a6.88,6.88,0,0,0-2.66-.39c0-.06.26-.26.79-.36a3.71,3.71,0,0,1,3.68,1.65C365.73,468,365.78,468.36,365.73,468.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.21,471.6c-.11.11-.87-.62-2.07-.92a17.63,17.63,0,0,0-2.26-.19,2.56,2.56,0,0,1,2.38-.31C363.63,470.52,364.33,471.53,364.21,471.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.62,464.21a23.51,23.51,0,0,0-3.11-1.64,24.54,24.54,0,0,0-3.44-.66,5.13,5.13,0,0,1,3.61.17A5.26,5.26,0,0,1,368.62,464.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.78,458.54c0,.14-1.34-.34-3-.33s-3,.48-3,.34a4.51,4.51,0,0,1,3-.86A4.46,4.46,0,0,1,368.78,458.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84,458.21a2.24,2.24,0,0,1,.09-.89,6.34,6.34,0,0,1,1-2.21,2.74,2.74,0,0,1,1.32-1.14.92.92,0,0,1,1,.37,1.59,1.59,0,0,1,.22,1.1,3.37,3.37,0,0,1-3.33,2.71,3.82,3.82,0,0,1-3.46-2.57,1.39,1.39,0,0,1,.09-1.14.91.91,0,0,1,1-.36,3.18,3.18,0,0,1,1.39,1,7,7,0,0,1,1.3,2,2.06,2.06,0,0,1,.24.86,11.14,11.14,0,0,0-1.79-2.63,3.28,3.28,0,0,0-1.24-.85.49.49,0,0,0-.56.2,1,1,0,0,0,0,.75,3.44,3.44,0,0,0,3,2.2,2.93,2.93,0,0,0,2.86-2.27,1.14,1.14,0,0,0-.12-.77.49.49,0,0,0-.56-.21,2.47,2.47,0,0,0-1.14.94A9.5,9.5,0,0,0,364.84,458.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,455.32c-.26-.43-2.53-9.71-2.53-9.71l15.73-3.81,1.84,13.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.08,452.52l0,1.06s17,7.49,17.11,10.9l-34-.72.72-11.86A18.6,18.6,0,0,0,424.08,452.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.21,463.76l.17-2.85,32.49,1.73s1.5.72,1.3,1.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.18,453.68c0,.18-.84.24-1.67.78s-1.28,1.27-1.43,1.19.12-1.07,1.13-1.71S424.22,453.52,424.18,453.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.71,455.3c0,.17-.69.46-1.27,1.18s-.76,1.5-.93,1.49-.24-1,.49-1.89S427.71,455.14,427.71,455.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.63,459.83c-.15,0-.36-.84.09-1.79s1.23-1.31,1.29-1.16-.42.64-.78,1.43S429.8,459.81,429.63,459.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.72,282.3s10,45.18,16.06,89.93c5,36.81,6.48,76.54,6.48,76.54l-17.67.54s-9.46-45.74-16.91-78.64C381.82,340.33,376,324.35,376,324.35L371.3,280Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.78,279.54S338.72,300,339.4,321.89c.41,13.09,22.67,130,22.67,130H379.9l-2.76-123.63,6.45-40.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.09,200.45a22,22,0,0,1-1.08,4.7,23.12,23.12,0,0,1-1.57,4.56,22.19,22.19,0,0,1,1.07-4.7A22,22,0,0,1,426.09,200.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.94,200.17l-3.08,10.21-1.14,1.73s-.85,5.65-.88,6.85,1.75,7.42,1.75,7.42l-3.29,5.7,9.77,3.37s2.44-5.19,3.15-5.79a6.23,6.23,0,0,0,1.3-3.4c.14-1.12,1.35-7.79,1.35-7.79s4-7.45,2.23-7.76a6.25,6.25,0,0,0-1.34.07s-2.41,4.9-3.1,5l-1-.53s1.76-7.42,1.81-8.8-.26-2.34-1.33-2.46c0,0-.78.35-.84.7s-1.78,8.62-2.24,8.48-.27-.89-.27-.89,2.33-10,2.18-10.6a1.56,1.56,0,0,0-1.64-1.31l-1.86,5.53s.8-4.63,0-5.42A1.28,1.28,0,0,0,425.94,200.17Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.75,222.43c-.08,0-.05-.86-.42-2.22a8.69,8.69,0,0,0-3.16-4.54l-.14-.09,0-.16c.15-.73.3-1.51.45-2.3v-.05l0,0c.16-.25.32-.53.47-.82a8.75,8.75,0,0,0,1-2.94,3.22,3.22,0,0,0-.07-1.36,1,1,0,0,0-.76-.72l.16-.07c-1.11,1.14-2.05,2.09-2.71,2.73a6.66,6.66,0,0,1-1.09,1,6.11,6.11,0,0,1,.91-1.14c.61-.7,1.5-1.68,2.58-2.85l.07-.08h.09a1.41,1.41,0,0,1,1.19,1,3.83,3.83,0,0,1,.11,1.58,9.07,9.07,0,0,1-1,3.12c-.16.3-.32.59-.5.86l0-.09c-.17.79-.32,1.56-.47,2.3l-.11-.25a8.47,8.47,0,0,1,3.19,4.87,7,7,0,0,1,.19,1.68C428.8,222.22,428.78,222.43,428.75,222.43Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.47,214.27a6.84,6.84,0,0,1,3.11,1.23,7,7,0,0,1,2.51,2.21,29.12,29.12,0,0,1-2.78-1.78A30.82,30.82,0,0,1,428.47,214.27Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.86,224.6a3,3,0,0,1,.07.65c0,.48.05,1.1.08,1.87.08,1.62.1,4,.07,6.88-.05,5.81-.55,13.83-1.38,22.65s-1.56,16.81-1.83,22.6c-.15,2.9-.24,5.25-.26,6.87,0,.77,0,1.39-.06,1.87a3.39,3.39,0,0,1-.05.65,2.59,2.59,0,0,1-.05-.65c0-.48,0-1.1,0-1.87,0-1.63,0-4,.1-6.88.18-5.81.85-13.82,1.68-22.64s1.39-16.81,1.54-22.61c.07-2.9.1-5.25.08-6.87,0-.77,0-1.39,0-1.87A3,3,0,0,1,403.86,224.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.21,229l-4.11,13.62-6.48-24.82a8.68,8.68,0,0,0-5.5-5.94l-5.74-1.47,5,49.43,1.33,3.74a9.86,9.86,0,0,0,4.87,5.16c5.91,2.88,13.56.1,15.32-6.24l9.1-29.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.46,225l2.9,56.18,36.69,1.34,3.36,3.62.29-45.1-11.81-32.45h0c-1.6,2.83-4.52,3.72-8,3.35-2.38-.25-6.7-.81-8.6-2.26l-4.86-4.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.29,202.16l-4,4.46-19.53,7.08L354,271.4l-9.66,22a54.32,54.32,0,0,0-2.57,7.11l-6.18,21.62s22.18,9.6,27.19,6.89S374,296.23,376,289.7s2.78-27.31,1.79-37.76-2.74-25.85-3.69-31.18S367.29,202.16,367.29,202.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,204.44l2.67,4.4,11.55,3.27s2.63,15.42,2.51,19.62-3.17,50.71-3.23,52.91,10.79,35.72,10,37.53c-.46,1.06-5.41,1.11-8.46,1.91a3.5,3.5,0,0,1-4.36-3.05c-.81-8.34-3.12-27.69-2.92-34.45.24-8.77,1-30-.48-40.69S389,208.76,389,208.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.41,291.77a.77.77,0,0,1,0-.22c0-.17,0-.39,0-.64,0-.6.06-1.42.11-2.46.11-2.18.27-5.25.46-9,.39-7.63,1-18.17,1.52-29.81.06-1.46.12-2.89.14-4.31s-.06-2.8-.13-4.17c-.14-2.75-.29-5.39-.47-7.91s-.41-4.9-.72-7.12a30.49,30.49,0,0,0-1.53-6,80.41,80.41,0,0,0-3.6-8.28l-1.11-2.19c-.12-.23-.22-.42-.29-.57s-.1-.2-.09-.2a1,1,0,0,1,.13.18l.33.55c.28.48.69,1.2,1.19,2.15A68.21,68.21,0,0,1,397.1,220a29.72,29.72,0,0,1,1.6,6.06c.34,2.23.57,4.63.77,7.15s.35,5.17.5,7.91c.06,1.37.19,2.77.14,4.21s-.09,2.86-.14,4.32c-.52,11.65-1.18,22.18-1.66,29.81-.26,3.78-.46,6.86-.61,9-.08,1-.15,1.85-.19,2.45,0,.26-.05.47-.06.64A.86.86,0,0,1,397.41,291.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.26,273.62a3.09,3.09,0,0,1-.09-.69c0-.45-.07-1.11-.1-2-.06-1.72-.09-4.21,0-7.29.07-1.54.18-3.22.35-5a22.68,22.68,0,0,0-.52-5.67,96.82,96.82,0,0,0-3.85-12.61c-1.64-4.39-3.34-8.53-4.92-12.27a50.62,50.62,0,0,1-2.1-5.4,45.94,45.94,0,0,1-1.05-4.94c-.5-3-.75-5.52-.91-7.24-.08-.85-.13-1.52-.15-2a2.79,2.79,0,0,1,0-.69,4.31,4.31,0,0,1,.1.68l.24,2c.21,1.71.51,4.18,1,7.2a49.64,49.64,0,0,0,1.1,4.89,52.25,52.25,0,0,0,2.12,5.34c1.61,3.74,3.33,7.87,5,12.28a92.8,92.8,0,0,1,3.83,12.69,23.33,23.33,0,0,1,.49,5.79c-.19,1.8-.32,3.48-.41,5-.18,3.06-.19,5.55-.19,7.27,0,.83,0,1.48,0,2S376.27,273.62,376.26,273.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.65,225.33a4.59,4.59,0,0,1,.06.6c0,.44,0,1,.08,1.72.07,1.5.09,3.68.06,6.36-.05,5.37-.51,12.78-1.28,20.93s-1.44,15.53-1.69,20.88c-.14,2.68-.22,4.85-.24,6.35l-.05,1.72a2.92,2.92,0,0,1,0,.61,2.92,2.92,0,0,1-.05-.61c0-.44,0-1,0-1.72,0-1.5,0-3.68.09-6.36.17-5.37.79-12.76,1.56-20.91s1.27-15.54,1.41-20.89c.07-2.68.1-4.85.08-6.35,0-.71,0-1.29,0-1.73A2.58,2.58,0,0,1,405.65,225.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.42,244.78a5.66,5.66,0,0,1,0-1.2c0-.77,0-1.89-.06-3.27a57.27,57.27,0,0,0-1.47-10.65,56,56,0,0,0-3.48-10.17c-.56-1.26-1.05-2.26-1.41-3a5.94,5.94,0,0,1-.5-1.09,5.6,5.6,0,0,1,.66,1c.41.66.94,1.65,1.55,2.9a50.16,50.16,0,0,1,3.64,10.2,50.86,50.86,0,0,1,1.34,10.75c0,1.39,0,2.51-.09,3.29A6,6,0,0,1,352.42,244.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.08,316s4.14,3.31,5,4.6,3.05,5.84,4.73,7.2a1.29,1.29,0,0,1-2.07.82,14.56,14.56,0,0,1-4.35-4c-.69-1.12-1.46-.5-1.53.46s.57,7.46.57,7.46,1.82,7.25,1.25,8.05a1.31,1.31,0,0,1-2.06,0c-.27-.38-2.37-6.46-2.37-6.46l-.5-3.29s.88,10.4.2,11.19a1.13,1.13,0,0,1-1.82,0c-.44-.42-.78-5-.78-5l-.9-6.15-.13,11.67s-.16,1.1-1,1.12-1.42-1.28-1.42-1.28L339,330.37s.22,6.69-.24,7-1.16.28-1.34-.24a66.49,66.49,0,0,1-.79-7.08l-.23-11.45-.43-5.52,10.72-.4Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55,245.28l-8.78-31.58s-5.16,6.06-6.74,12c-2.67,10-8.93,42.28-8.56,48.73s3.85,43.52,3.85,43.52l16.57-3.27-1.78-42.24Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,258.62a8,8,0,0,0,1.29-1.93,32,32,0,0,0,1.73-5.4,36.9,36.9,0,0,0,.85-5.62,18.37,18.37,0,0,1,.18-2.36,9.91,9.91,0,0,1,.13,2.38,27.69,27.69,0,0,1-.73,5.7,25.19,25.19,0,0,1-1.88,5.44A3.62,3.62,0,0,1,384,258.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,201.71a1.56,1.56,0,0,0-1.64-1.31l-1.86,5.54s.8-4.63,0-5.43a1.28,1.28,0,0,0-1.57-.33l-3.08,10.21-.1.15c-.14.17-.21.28-.19.29l-.85,1.29s-.85,5.65-.88,6.85,1.75,7.42,1.75,7.42l-1.92,3.33-2.46-.76-4.11,13.62-6.48-24.82a8.76,8.76,0,0,0-4.33-5.42l0-.22-11.55-3.27s11.7,4.39,13.62,8.34c2.55,5.24,5.44,24.81,7.84,27s6.14-13.51,6.14-13.51l5.49.26L423,217.34l.48-5,3.52-5.15s.42.15.91-.41,1.51-5.22,1.87-5.22A8.5,8.5,0,0,1,431,201.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.77,213.71h0s-.12.12-.33.38-.53.63-.92,1.15a42,42,0,0,0-3.13,4.71,30.18,30.18,0,0,0-1.78,3.68,36.59,36.59,0,0,0-1.36,4.67c-.82,3.39-1.68,7.27-2.56,11.57s-1.81,9-2.72,14.09-1.85,10.51-2.48,16.29a29.56,29.56,0,0,0-.2,4.43c.13,1.48.26,3,.39,4.49.26,3,.54,6.11.81,9.25s2.76,26.27,3,29.49l-.39-21.41c-.5-8.42-2.28-19.32,1.56-33.53s9.61-37.84,11.48-42.7,18.12-13.64,18.12-13.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.84,218.36a14.59,14.59,0,0,0-1.73-3.66,14.8,14.8,0,0,0-3-2.68,2.35,2.35,0,0,1,1.18.4,7.21,7.21,0,0,1,3.54,4.7A2.32,2.32,0,0,1,407.84,218.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.58,211.36a44.88,44.88,0,0,0-.44,7.3,44.08,44.08,0,0,0,1.32,7.19,6.38,6.38,0,0,1-.87-2,21.37,21.37,0,0,1-1-5.17,20.89,20.89,0,0,1,.34-5.24A7,7,0,0,1,421.58,211.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.3,206.62l-.27.12-.82.31-3.13,1.13c-2.72,1-6.66,2.37-11.5,4.18l-1.85.71a16.49,16.49,0,0,0-1.83.79,18.62,18.62,0,0,0-2.8,3.32,32,32,0,0,0-4,8.75A46.7,46.7,0,0,0,336,231q-.51,2.64-1,5.38c-.7,3.65-1.43,7.44-2.17,11.31-1.46,7.75-3,15.14-4.16,21.84a36,36,0,0,0,0,9.62c.3,3,.58,5.84.83,8.42l1.17,12.19c.13,1.41.23,2.52.3,3.31,0,.36,0,.64.06.87a1.07,1.07,0,0,1,0,.29A1,1,0,0,1,331,304l-.12-.86c-.09-.79-.22-1.9-.39-3.3-.32-2.92-.77-7.06-1.33-12.18-.28-2.57-.58-5.38-.9-8.4a36.38,36.38,0,0,1-.06-9.74c1.19-6.76,2.66-14.11,4.13-21.87.75-3.87,1.47-7.65,2.18-11.3q.52-2.75,1-5.38a45.69,45.69,0,0,1,1.18-5.13,32.14,32.14,0,0,1,4.05-8.86,19.42,19.42,0,0,1,2.88-3.37,13,13,0,0,1,2-.86l1.86-.7c4.86-1.76,8.83-3.1,11.57-4l3.16-1,.83-.26A1.43,1.43,0,0,1,363.3,206.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.91 253.91 357.46 269.81 349.05 282.66 354.01 271.4 350.91 253.91",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.11,247.44a2.11,2.11,0,0,1-.05.48c-.06.35-.14.81-.24,1.37-.23,1.25-.56,3-1,5.16l-3.52,18v0c.22,5.12.46,10.77.72,16.72.39,9.63.74,18.5,1,25.52v.18l-.17,0L337,317.14l-3.29.6-.87.14a1.1,1.1,0,0,1-.3,0,1.32,1.32,0,0,1,.29-.09l.85-.2,3.27-.71,11.91-2.46-.17.22c-.31-7-.7-15.89-1.13-25.52-.24-5.95-.47-11.6-.68-16.72v-.06c1.51-7.31,2.79-13.53,3.7-18,.46-2.16.83-3.89,1.1-5.13.13-.56.23-1,.31-1.36A2.47,2.47,0,0,1,352.11,247.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.46,304.59a3,3,0,0,1,.81.19l2.2.69c1.87.61,4.52,1.5,7.61,2.56l-.31.13c.7-1.71,1.45-3.57,2.24-5.52l.87-2.1.15.34c-4-1.38-7.46-2.62-10-3.53l-2.93-1.1a5.52,5.52,0,0,1-1.05-.46,5.46,5.46,0,0,1,1.11.28l3,.95c2.53.83,6,2,10,3.37l.26.09-.1.25-.86,2.11c-.81,1.94-1.57,3.8-2.28,5.51l-.09.21-.22-.07c-3.07-1.09-5.69-2-7.54-2.73l-2.15-.83A4,4,0,0,1,348.46,304.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.41,241.73a14.73,14.73,0,0,1-.75,2.3c-.48,1.4-1.1,3.36-1.62,5.56a57,57,0,0,0-1,5.71,13.54,13.54,0,0,1-.35,2.39,8.83,8.83,0,0,1,0-2.43,36.1,36.1,0,0,1,.88-5.79,35.66,35.66,0,0,1,1.79-5.57A9,9,0,0,1,414.41,241.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.66,439.11a3.29,3.29,0,0,1-.17-.7l-.39-2-1.39-7.46c-1.2-6.3-3-15-4.92-24.55s-3.68-18.28-4.78-24.6c-.56-3.16-1-5.72-1.23-7.49-.12-.85-.22-1.53-.29-2a3.15,3.15,0,0,1-.06-.71,5,5,0,0,1,.17.7c.09.51.22,1.19.38,2,.34,1.81.81,4.35,1.39,7.45,1.2,6.3,3,15,4.93,24.56s3.67,18.28,4.77,24.59c.56,3.16,1,5.72,1.23,7.5.12.84.22,1.52.29,2A5.47,5.47,0,0,1,359.66,439.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.35,165.1,86,176.68l.77,2.13s-.54,6.19-.82,7.46-3.73,7.41-3.73,7.41l2,6.86-11.2,1.08s-1.25-6.1-1.85-6.92-.66-2.7-.52-3.93.56-8.58.56-8.58-2.36-8.91-.38-8.78l.16,0a1.87,1.87,0,0,1,1.48,1.44c.41,1.68,1.25,4.82,1.75,5.05l1.19-.32s0-8.29.32-9.76.87-2.41,2-2.27c0,0,.74.57.71,1s-.3,9.57.22,9.54.51-.87.51-.87.09-11.21.39-11.77a1.7,1.7,0,0,1,2.07-1l.55,6.32s.34-5.09,1.36-5.74A1.39,1.39,0,0,1,85.35,165.1Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.71,187.93c.09,0,.28-.89,1-2.24a9.34,9.34,0,0,1,4.49-4l.17-.07v-.17c0-.82.07-1.67.11-2.55v-.06l0,0c-.1-.3-.2-.64-.29-1a9.62,9.62,0,0,1-.32-3.37,3.52,3.52,0,0,1,.41-1.43,1.05,1.05,0,0,1,1-.56l-.16-.12c.89,1.5,1.64,2.73,2.18,3.58a7.22,7.22,0,0,0,.91,1.31,6.61,6.61,0,0,0-.67-1.44c-.47-.9-1.16-2.16-2-3.68l0-.09-.11,0a1.51,1.51,0,0,0-1.5.75,3.9,3.9,0,0,0-.52,1.63,10,10,0,0,0,.31,3.58c.1.36.2.7.32,1l0-.1q0,1.32-.09,2.55l.18-.24a9.16,9.16,0,0,0-4.61,4.34,7.82,7.82,0,0,0-.63,1.73A2.05,2.05,0,0,0,76.71,187.93Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.09,179.37a7.39,7.39,0,0,0-3.6.51,7.51,7.51,0,0,0-3.22,1.7,32.57,32.57,0,0,0,3.39-1.18A32.63,32.63,0,0,0,79.09,179.37Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,136a4.27,4.27,0,0,0-4.39-2.26,5.83,5.83,0,0,0-7.18,0,5.18,5.18,0,0,0-7.91,4.07,4.34,4.34,0,0,0-3.93,7.23,4.16,4.16,0,0,0,1.58,8.13l21-12.31A4.28,4.28,0,0,0,146,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.59,153.71a17.67,17.67,0,0,1,17.94-15.88l.92,0c9.85.78,14.69,9.58,13.64,19.41L154,190.08l-1.44,4.1-17,21.27-4.27-19.16-.09-8.9s-9.45-1.67-9.37-11.15C121.88,171.66,122.72,162.23,123.59,153.71Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.23,187.41A23,23,0,0,0,143.64,184s-3,6.78-12.4,5.76Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8,163a1.35,1.35,0,0,0,1.28,1.39,1.3,1.3,0,0,0,1.42-1.19,1.35,1.35,0,0,0-1.28-1.39A1.29,1.29,0,0,0,127.8,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.8,163a1.36,1.36,0,0,0,1.28,1.39,1.29,1.29,0,0,0,1.42-1.19,1.35,1.35,0,0,0-1.27-1.39A1.29,1.29,0,0,0,140.8,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41,158.87c.17.18,1.21-.56,2.67-.52s2.51.78,2.67.61-.09-.4-.55-.75a3.71,3.71,0,0,0-2.13-.71,3.58,3.58,0,0,0-2.12.64C125.49,158.48,125.33,158.79,125.41,158.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,159.61c.17.18,1.21-.55,2.67-.52s2.51.78,2.67.61-.09-.4-.55-.75a3.71,3.71,0,0,0-2.13-.71,3.58,3.58,0,0,0-2.12.64C140.05,159.22,139.89,159.53,140,159.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.34,169.66a9.43,9.43,0,0,0-2.36-.48c-.37,0-.72-.13-.78-.38a1.91,1.91,0,0,1,.27-1.1c.37-.89.75-1.83,1.16-2.81,1.61-4,2.78-7.3,2.62-7.36s-1.6,3.13-3.21,7.13l-1.11,2.83a2.15,2.15,0,0,0-.22,1.46.91.91,0,0,0,.6.55,2.16,2.16,0,0,0,.63.1A9.94,9.94,0,0,0,134.34,169.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.69,155.88c.16.38,1.43.07,2.95.13s2.79.4,3,0c.07-.17-.17-.52-.7-.86a4.58,4.58,0,0,0-2.25-.64,4.35,4.35,0,0,0-2.25.53C139.86,155.36,139.62,155.7,139.69,155.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83,154.88c.22.36,1.25.12,2.45.23s2.2.45,2.47.13c.12-.16,0-.51-.42-.86a3.39,3.39,0,0,0-1.94-.75,3.46,3.46,0,0,0-2,.46C125.9,154.39,125.73,154.71,125.83,154.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,149.38s2.62-5.88,5.51-7.21c3.5-1.61,4.92,2.23,8.24,1.37s6.67-2.39,10,.23c3.64,2.87,1.86,4.8,2,9,.57,17.07,3.59,22,4.64,13.95.11-.88,2.57-1.53,3-5.24.57-4.82.87-10.67-.13-14.11-.85-2.91-2.45-4.93-5.36-7.19-4.58-3.56-11-3.77-15.33-3.42S124.35,141.94,124.59,149.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.38,166.46a2.57,2.57,0,0,1,2.83-2.43c1.76.21,3.71,1.25,3.52,4.9-.34,6.48-6.78,4.8-6.78,4.62S154.21,169.16,154.38,166.46Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,171.18s.11.09.3.19a1.14,1.14,0,0,0,.84.06,2.79,2.79,0,0,0,1.42-2.44,3.73,3.73,0,0,0-.23-1.63,1.29,1.29,0,0,0-.8-.91.56.56,0,0,0-.68.27c-.1.18-.07.31-.1.32s-.14-.12-.07-.38a.67.67,0,0,1,.28-.39.88.88,0,0,1,.63-.14,1.61,1.61,0,0,1,1.13,1.07,3.76,3.76,0,0,1,.29,1.83,2.93,2.93,0,0,1-1.79,2.71,1.22,1.22,0,0,1-1-.23C155.49,171.34,155.47,171.19,155.49,171.18Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.51,153.89a6.14,6.14,0,0,1-2.77,1.21,2.11,2.11,0,0,1-2.32-1.53c-.06-.45.06-1-.23-1.33s-1-.31-1.55-.26a4.13,4.13,0,0,1-4.23-3.06,1.75,1.75,0,0,1-2.34.18,9.62,9.62,0,0,1-1.72-1.93,2.7,2.7,0,0,0-2.2-1.16,6,6,0,0,1-1.42.28c-.85-.09-1.25-1.09-1.36-1.94s-.19-1.84-.9-2.31a3.39,3.39,0,0,0-2.32-.11c-.78.1-1.79-.11-2-.88a1.58,1.58,0,0,1,.32-1.17,4.2,4.2,0,0,1,5-1.49,5.69,5.69,0,0,1,10.48-.88,5.77,5.77,0,0,1,9.18,2.29,4.19,4.19,0,0,1,4.6,6.19,4,4,0,0,1,2.12,3.21,2.28,2.28,0,0,1-2.63,2.27,2.32,2.32,0,0,1-4,2.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.89,172.05a.56.56,0,0,1,.43-.07.5.5,0,0,1,.25.3,3.27,3.27,0,0,1-.36,3.13l0,0a2.18,2.18,0,0,1-3.67-.47l-.51-1.09Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.88,175.5c-.06,0,.43.67,1.6.81a1.8,1.8,0,0,0,1-.15,2.17,2.17,0,0,0,.91-.66,3.85,3.85,0,0,0,.64-2.36,3.74,3.74,0,0,0,0-.66,1,1,0,0,0-.38-.65.75.75,0,0,0-.75,0l-.5.25-1.71.89a7.46,7.46,0,0,0-1.53.92,7.74,7.74,0,0,0,1.66-.65l1.75-.81c.32-.13.73-.4.86-.28s.22.56.23.95a3.71,3.71,0,0,1-.54,2.13,1.75,1.75,0,0,1-.73.56,1.45,1.45,0,0,1-.79.18A3.66,3.66,0,0,1,134.88,175.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.71,151.47a1.55,1.55,0,0,1-.43,1.23,2.08,2.08,0,0,1-1.31.75,2.24,2.24,0,0,1-1.84-.57l.27,0a6.46,6.46,0,0,1-1.32,1.59,3.66,3.66,0,0,1-1.2.71,2.86,2.86,0,0,1-3.16-1,3.7,3.7,0,0,1-.49-1.36,1.29,1.29,0,0,1,0-.52s.08.17.18.49a4.2,4.2,0,0,0,.57,1.24,2.64,2.64,0,0,0,3.89.18,6.46,6.46,0,0,0,1.27-1.49l.12-.19.16.15a1.92,1.92,0,0,0,2.73-.06A3.15,3.15,0,0,0,158.71,151.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.77,136.41s-.17,0-.47.16a2.2,2.2,0,0,0-1,.83l-.08.12-.09-.12a8.09,8.09,0,0,0-3.08-2.6,6.13,6.13,0,0,0-2.54-.61,5.23,5.23,0,0,0-2.76.72,5.32,5.32,0,0,0-1.67,1.52,4.44,4.44,0,0,0-.75,1.94l0,.2-.19,0a3.63,3.63,0,0,0-2.7.27,3.55,3.55,0,0,0-1.51,1.55,4.58,4.58,0,0,0-.44,1.91,1.13,1.13,0,0,1-.07-.53,3.54,3.54,0,0,1,.32-1.47,3.7,3.7,0,0,1,1.56-1.71,3.84,3.84,0,0,1,2.94-.35l-.22.14a4.63,4.63,0,0,1,.79-2.11,5.7,5.7,0,0,1,1.78-1.63,5.48,5.48,0,0,1,3-.76,6.35,6.35,0,0,1,2.67.68,7.78,7.78,0,0,1,3.11,2.78h-.17a2.17,2.17,0,0,1,1.16-.82C146.59,136.38,146.77,136.39,146.77,136.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.76,434.68l-.13,17.81s-18.15,5.85-18.5,9.15l34.54,1.49L143,435.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,451.46a1.4,1.4,0,0,1,.9,1.65,1.35,1.35,0,0,1-1.63.91,1.5,1.5,0,0,1-1-1.75,1.43,1.43,0,0,1,1.81-.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67,463.13l0-2.8-33.13-.39s-1.56.6-1.44,1.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.08,452.29c0,.17.84.29,1.65.86s1.21,1.31,1.37,1.25,0-1-1-1.73S125.05,452.14,125.08,452.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.39,453.64c0,.16.68.48,1.22,1.21s.67,1.5.84,1.5.32-1-.37-1.85S121.4,453.47,121.39,453.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.15,457.88c.15,0,.42-.79,0-1.73s-1.17-1.34-1.24-1.21.38.66.7,1.43S119,457.86,119.15,457.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.56,448.24c.07.15.85-.05,1.8.06s1.68.44,1.77.3-.59-.78-1.71-.88S125.48,448.1,125.56,448.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.81,438.47,167.69,460l-3.42,17.41a2.21,2.21,0,0,0,1.89,2.62h0a2.22,2.22,0,0,0,1.9-.7c3.08-3.36,14.35-15.77,14.13-17.33-.26-1.82-.47-22.79-.47-22.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,480l15.94-19.49.05.92a3.35,3.35,0,0,1-.64,2.2c-1.27,1.69-4.86,6.29-13.39,15.67a2.21,2.21,0,0,1-2,.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.23,453.84a1.34,1.34,0,0,0-.25,1.76,1.29,1.29,0,0,0,1.75.27A1.42,1.42,0,0,0,179,454a1.33,1.33,0,0,0-1.85-.08",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.47,470.26a6.53,6.53,0,0,0-2-1.55,6.62,6.62,0,0,0-2.51-.32c0-.05.24-.23.74-.34a3.48,3.48,0,0,1,1.95.22,3.39,3.39,0,0,1,1.53,1.23C170.47,469.92,170.53,470.24,170.47,470.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,473.24a17.77,17.77,0,0,0-2-.8,16.36,16.36,0,0,0-2.12-.14,2.45,2.45,0,0,1,2.23-.33C168.56,472.26,169.23,473.17,169.13,473.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.09,466.38a23.09,23.09,0,0,0-3-1.44,20.94,20.94,0,0,0-3.24-.54,6,6,0,0,1,6.19,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.07,459.81c0,.13-1.27-.29-2.82-.25s-2.76.5-2.81.37a5.47,5.47,0,0,1,5.63-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.68,453.49a10.9,10.9,0,0,0-2.93-.33,10.34,10.34,0,0,0-2.81.9c0-.05.18-.33.66-.65a4.83,4.83,0,0,1,4.31-.42C172.44,453.2,172.71,453.44,172.68,453.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.71,452a1.66,1.66,0,0,1-.08-.81,5.47,5.47,0,0,1,.51-2.17,2.46,2.46,0,0,1,1-1.27.89.89,0,0,1,1,.14,1.45,1.45,0,0,1,.4,1,3.12,3.12,0,0,1-2.55,3,3.62,3.62,0,0,1-3.67-1.66,1.25,1.25,0,0,1-.12-1,.87.87,0,0,1,.88-.52,3.13,3.13,0,0,1,1.46.65,6.29,6.29,0,0,1,1.58,1.58c.29.43.4.71.37.72a10,10,0,0,0-2.14-2,2.77,2.77,0,0,0-1.29-.53.46.46,0,0,0-.48.28.83.83,0,0,0,.13.67,3.2,3.2,0,0,0,3.2,1.41,2.71,2.71,0,0,0,2.19-2.57,1,1,0,0,0-.25-.67.47.47,0,0,0-.56-.08,2.23,2.23,0,0,0-.86,1.05A8.35,8.35,0,0,0,169.71,452Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,287a76.52,76.52,0,0,0-1.67,22.51c.37,4.78,16.51,137.14,16.51,137.14h21.8L138,322.22l1.79.39s11.9,53.05,12.87,61.64c.87,7.73,11.56,68.41,11.56,68.41l20.56-.22-7.65-78.34-7.41-71.19L167,282.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.45,309.53a4,4,0,0,1-.91.51,10.37,10.37,0,0,1-2.7.95,5.63,5.63,0,0,1-2,0,4.13,4.13,0,0,1-2.1-1,5,5,0,0,1-1.27-2.23c-.26-.85-.4-1.73-.58-2.62-.7-3.59-1.17-6.87-1.44-9.25-.14-1.19-.23-2.15-.28-2.82a4.69,4.69,0,0,1,0-1.05,5.37,5.37,0,0,1,.21,1c.11.75.25,1.69.42,2.8.36,2.36.88,5.62,1.57,9.2.35,1.77.59,3.57,1.7,4.63a4.56,4.56,0,0,0,3.76,1,12.77,12.77,0,0,0,2.68-.79A5.68,5.68,0,0,1,141.45,309.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,292.66s.14-.11.45-.13a2,2,0,0,1,1.22.39,2.2,2.2,0,0,1,.92,1.68,2.06,2.06,0,0,1-1.4,1.88,2,2,0,0,1-2.28-.5,2.14,2.14,0,0,1-.42-1.87A2,2,0,0,1,134,293c.24-.18.42-.21.43-.19a2.46,2.46,0,0,0-.77,1.35,1.89,1.89,0,0,0,.41,1.53,1.77,1.77,0,0,0,2.94-1.1,1.91,1.91,0,0,0-.69-1.42A2.42,2.42,0,0,0,134.89,292.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.43,301.63s-.26.07-.74.12a14.53,14.53,0,0,1-2,0,19.55,19.55,0,0,1-6.57-1.52,19.75,19.75,0,0,1-5.67-3.63,12.58,12.58,0,0,1-1.41-1.48,2.55,2.55,0,0,1-.44-.61c.06-.06.76.74,2.06,1.84a21.93,21.93,0,0,0,12,5.08C168.36,301.61,169.43,301.55,169.43,301.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.44,293.06a8.92,8.92,0,0,1-1,2.22,24.63,24.63,0,0,1-3.37,4.69,22.64,22.64,0,0,1-4.27,3.65,7.81,7.81,0,0,1-2,1.07,21.76,21.76,0,0,1,1.86-1.35,28.62,28.62,0,0,0,4.13-3.7,30.87,30.87,0,0,0,3.41-4.53C116,293.85,116.38,293,116.44,293.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.8,188.08l-11,8.65-5.84,4.3-2.22.12-1.49-4.74-1.84-7.22-3,3-7.62,16.24-8.58,78.47s15,4.38,22.71,4.92,20.1-1.6,20.1-1.6V248.91L159.36,208l-5.3-15.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48,291.27s0-.07,0-.22l0-.64c0-.59.05-1.43.09-2.49.07-2.18.18-5.3.31-9.15.26-7.72.69-18.38,1.3-30.15s1.29-22.43,1.82-30.14c.26-3.84.48-6.95.63-9.13.07-1.06.13-1.89.17-2.48,0-.27,0-.48,0-.65s0-.22,0-.22a.86.86,0,0,0,0,.22c0,.16,0,.37-.07.64,0,.59-.12,1.42-.22,2.48-.19,2.15-.45,5.27-.74,9.12-.59,7.71-1.3,18.36-1.92,30.14s-1,22.44-1.2,30.17c-.11,3.86-.18,7-.21,9.15,0,1.06,0,1.9,0,2.48v.65A1.76,1.76,0,0,0,131.48,291.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,192.16l2.56,3.52,20.92,11L167.35,242.2l-3.13,19.91L176,309.41s-14.27,4.91-15.52,3.34a65.06,65.06,0,0,1-3.59-7.78,83.76,83.76,0,0,1-6-23.24c-.87-8.05-1.67-18.31-1.09-25.27,1.1-13,2.83-34.49,3-40.14s1.16-26.95,1.16-26.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.1,189.37l-6.39,3.06L107,196.05l-2.34,20.55,2,40.67L96.33,307.58s7.52,2.66,10.5,1.56,7.06-7.83,7.22-11.91,6-43.59,6-43.59l4.94-46.45a38.13,38.13,0,0,1,3.67-12.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.55,194.09a2.2,2.2,0,0,0-.29.32l-.77,1c-.69.85-1.66,2.07-2.88,3.6l-.06.08.08.06,2.44,1.85,0-.2-2.86.9-.09,0v.09c.06,5.1.13,11.52.2,18.48.12,8.5.24,16.18.32,21.78,0,2.77.1,5,.13,6.6,0,.76,0,1.36,0,1.79,0,.19,0,.35,0,.47s0,.16,0,.16,0-.06,0-.16,0-.28,0-.47c0-.43,0-1,0-1.79,0-1.59,0-3.84,0-6.6,0-5.6-.13-13.29-.22-21.78-.1-7-.19-13.38-.26-18.48l-.09.13,2.85-.94.22-.06-.18-.14-2.46-1.82,0,.14,2.8-3.66c.31-.41.55-.74.74-1A3.57,3.57,0,0,0,122.55,194.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.43,249.72s0-.05.06-.15l.15-.46.57-1.76c.5-1.52,1.24-3.72,2.2-6.43L155,236.5a50.55,50.55,0,0,0,1.6-5.15,117.47,117.47,0,0,0,2.25-12.15c.78-5.65,1.28-11,1.58-15.56v-.07l-.05,0-2.46-2.38v.2c.82-.64,1.6-1.23,2.33-1.78l.09-.07-.06-.09-4.22-5.73c-.5-.65-.88-1.17-1.16-1.54l-.31-.4c-.07-.09-.11-.13-.12-.13l.09.15.28.42,1.11,1.58,4.14,5.78,0-.16-2.35,1.76-.12.09.11.1,2.45,2.4,0-.11c-.34,4.57-.85,9.9-1.63,15.54a119.94,119.94,0,0,1-2.21,12.12c-.47,1.83-1,3.55-1.57,5.13s-1.08,3.08-1.55,4.44c-.93,2.71-1.64,4.93-2.1,6.46-.23.77-.4,1.37-.51,1.78l-.12.47C150.43,249.66,150.42,249.72,150.43,249.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.98 276.69 110.11 282.5 99.53 281.52 102.83 275.97 111.98 276.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,276.69a4.09,4.09,0,0,0-.63-.08l-1.85-.18c-1.6-.16-3.91-.38-6.66-.6h-.09l0,.08-3.32,5.54-.13.22.26,0,.54.05,10,.89h.1l0-.09c.57-1.82,1-3.3,1.31-4.31l.34-1.15a1.94,1.94,0,0,0,.1-.39,2.89,2.89,0,0,0-.16.43c-.11.3-.24.69-.41,1.16-.35,1-.83,2.46-1.42,4.18l.13-.09-10-1-.54-.05.12.24,3.29-5.55-.14.07c2.68.19,4.94.34,6.56.43l1.9.12C111.72,276.69,112,276.7,112,276.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28,201.77l-1.74,2.41s.48,36.5,2.34,45.56Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.78,269.87a62.68,62.68,0,0,0,1.16-7.45,42,42,0,0,0-.37-6.42c-.87-7.25-12.72-49.29-12.72-49.29l-11.92,32.76,6.24,21.76-7.1,43.55,16.59,3.33S188.44,279.76,190.78,269.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.22,262.11c.15,0,2.24-10.8,4.68-24.17s4.29-24.23,4.14-24.26-2.24,10.79-4.67,24.17S164.07,262.08,164.22,262.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,261.23a2.51,2.51,0,0,0-.15.6c-.09.46-.2,1-.34,1.75L171.55,270c-.92,5.51-2.17,13-3.56,21.29-.78,4.85-1.51,9.43-2.16,13.43l0,.23.23,0,12,2.31,3.41.61a6.39,6.39,0,0,0,1.22.17,8.09,8.09,0,0,0-1.19-.32l-3.38-.74-12-2.5.19.27c.66-4,1.42-8.58,2.22-13.42,1.32-8.29,2.51-15.8,3.39-21.32l1-6.47c.1-.71.17-1.3.24-1.76A2.89,2.89,0,0,0,173.17,261.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.83 201.01 84.83 197.37 70.13 197.03 70.07 200.68 84.83 201.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,196.05c-2.19,1.22-4.46,3.84-9.21,12.39L86.12,221.87,85.45,201l-15.79-.3s-.2,23.5,0,29.45C69.9,237.56,72,246.36,83,245.58c10.38-.73,24.49-18.39,24.49-18.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.34,209.45c.14,0,1,10.24,1.92,22.89s1.55,22.93,1.4,22.94-1-10.24-1.92-22.9S103.2,209.46,103.34,209.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.47,233.76a58.39,58.39,0,0,0,.74-7c0-3.89-.54-7-.37-7.05a7.21,7.21,0,0,1,.5,2,28.6,28.6,0,0,1,.39,5,23.16,23.16,0,0,1-.59,5A6.45,6.45,0,0,1,85.47,233.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.64,195.68a4.15,4.15,0,0,1-.66.77c-.45.47-1.1,1.15-1.93,2-1.64,1.65-3.93,3.9-6.49,6.36l-1.69,1.63-.29.27-.13-.36c-.85-2.32-1.62-4.41-2.25-6.14l.3.07c-.9.83-1.64,1.49-2.16,1.94a4.27,4.27,0,0,1-.84.66s.22-.32.7-.81,1.17-1.2,2-2.06l.2-.2.11.26,2.38,6.09-.42-.09,1.69-1.64c2.56-2.46,4.89-4.67,6.6-6.25.85-.79,1.55-1.42,2-1.85S153.61,195.65,153.64,195.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,202.11a22,22,0,0,1-1.55-3.34l.34.06a23.28,23.28,0,0,0-3,5.27c-.14.33-.26.65-.37,1l-.28.76-.21-.78a25.61,25.61,0,0,1-.91-6.24,9,9,0,0,1,.16-2.55,22.05,22.05,0,0,1,.19,2.54,32.13,32.13,0,0,0,1,6.11l-.49,0c.12-.31.24-.64.38-1a21,21,0,0,1,3.21-5.33l.22-.27.12.32A24.14,24.14,0,0,1,134,202.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.15 204.22 134.22 207.27 137.33 207.27 138.99 204.22 137.41 200.88 134.7 200.49 132.15 204.22",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.1 205.72 124.73 276.47 132.75 287.32 140.76 275.81 137.21 205.72 134.1 205.72",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.86,282.63a8.25,8.25,0,0,1-.1,1.56l-.47,4.23c-.22,1.82-.49,3.93-.77,6.27a37.56,37.56,0,0,1-1.89,7.53c-1,2.55-2.23,5.07-4.39,6.4a6.71,6.71,0,0,1-3.35.8,16.85,16.85,0,0,1-3-.25,28.56,28.56,0,0,1-4.14-1,7.62,7.62,0,0,1-1.46-.57,11.63,11.63,0,0,1,1.51.37,34.15,34.15,0,0,0,4.15.86,16.59,16.59,0,0,0,2.89.17,6.05,6.05,0,0,0,3.12-.78c2-1.22,3.2-3.65,4.14-6.16,1.94-5.11,2.19-10.13,2.78-13.67.26-1.7.48-3.12.64-4.2A9.93,9.93,0,0,1,115.86,282.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.07,341.65s-2.08-20.46-6.85-22.77-11.39-3.85-13.23-.8a36.16,36.16,0,0,0-4.5,12.53,77.36,77.36,0,0,0-.4,12.36l5.45-.57S161.43,322,163.11,319s10.06-.52,10.95,3.12,2.79,19.93,2.79,19.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.85,370.61c-.19-8.44-.86-27-1.16-35.21a4.15,4.15,0,0,0-4.14-4l-50.14-.07a4.16,4.16,0,0,0-4.16,4L139,370a4.16,4.16,0,0,0,4.11,4.3l52.53.6A4.15,4.15,0,0,0,199.85,370.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.67,344s0,.12,0,.37,0,.64,0,1.12c0,1,0,2.46,0,4.32,0,3.79,0,9.25,0,16v1.28a2.5,2.5,0,0,0,.28,1.33,2.28,2.28,0,0,0,1,1,2.92,2.92,0,0,0,1.39.21l5.74,0,12.64.07,14,.07,7.4,0,3.78,0h1a4.3,4.3,0,0,0,1-.05,2.3,2.3,0,0,0,1.57-1.26,2.19,2.19,0,0,0,.22-.87c0-.3,0-.55,0-.83,0-.55,0-1.1,0-1.65,0-1.09,0-2.18,0-3.25q0-3.24-.09-6.39c-.06-4.18-.11-8.24-.17-12.11v-.18h-.19c-14.41.77-26.77.92-35.51.89-4.38,0-7.85-.06-10.22-.09l-2.74,0h-.93l.25,0,.71,0,2.7.1c2.38.08,5.85.16,10.23.2,8.75.09,21.11,0,35.53-.76l-.18-.17c.05,3.87.1,7.92.15,12.11q0,3.13.09,6.38c0,1.08,0,2.17,0,3.26l0,1.64a3.25,3.25,0,0,1-.19,1.54,1.9,1.9,0,0,1-1.32,1.05,3.79,3.79,0,0,1-.91.05h-1l-3.78,0-7.4,0-14-.05-12.65,0h-5.74a2.64,2.64,0,0,1-1.27-.18,2,2,0,0,1-.91-.83,2.24,2.24,0,0,1-.25-1.2c0-.43,0-.85,0-1.27-.05-6.71-.09-12.15-.12-15.93,0-1.87,0-3.34-.05-4.35,0-.49,0-.87,0-1.14S143.67,344,143.67,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.91,366.38s-.3,0-.87-.12a4.46,4.46,0,0,1-2.16-1.22,4.57,4.57,0,0,1-1.2-3.66c0-1.57,0-3.36,0-5.34,0-1,0-2,0-3.11a4.45,4.45,0,0,1,.91-3.06,4.13,4.13,0,0,1,3-1.55c1.22,0,2.51,0,3.82,0h17a4.14,4.14,0,0,1,3.56,2,4,4,0,0,1,.58,2c0,.73,0,1.44,0,2.15,0,1.43,0,2.83,0,4.2v2a18,18,0,0,1,0,2,4.17,4.17,0,0,1-3.63,3.53c-.56,0-1.18,0-1.75,0l-6.48,0-9.38.07-2.55,0-.66,0-.23,0,.23,0,.66,0,2.55,0,9.38,0h6.48c.58,0,1.16,0,1.79,0a4.54,4.54,0,0,0,1.79-.61,4.46,4.46,0,0,0,2.14-3.19,19.44,19.44,0,0,0,.06-2v-2c0-1.37,0-2.77,0-4.2,0-.71,0-1.43,0-2.16a4.44,4.44,0,0,0-.63-2.17,4.55,4.55,0,0,0-3.88-2.2l-17,0c-1.32,0-2.58,0-3.84,0a4.45,4.45,0,0,0-3.21,1.69,4.64,4.64,0,0,0-1,3.25c0,1.08,0,2.12,0,3.11,0,2,0,3.77,0,5.34a10.76,10.76,0,0,0,0,1.15,4.36,4.36,0,0,0,.25,1.05,4.53,4.53,0,0,0,1,1.56,4.36,4.36,0,0,0,2.25,1.19A3,3,0,0,0,157.91,366.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192,369.63a80.09,80.09,0,0,1-45.91-.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M163.72,353.53h5.92a1.68,1.68,0,0,0,1.68-1.68h0a1.68,1.68,0,0,0-1.69-1.67h-5.91a1.68,1.68,0,0,0-1.68,1.68h0A1.67,1.67,0,0,0,163.72,353.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.59,312.06a17.69,17.69,0,0,0-2.54,3.28c-.62,1.31-1.5,6.86-1.5,6.86s1.08.84,2.68-2.17a27,27,0,0,0,2-4.5Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.71,322.32l1.78-10.14,5.37-6.68,12.39,2.23-2,12.31s-2.86,4.88-3.92,5.7-2.64-.26-2.64-.26c-1.23,1.27-3.68.23-3.68.23-1.55,1.24-3.22-.56-3.22-.56s-2,1.23-2.8,1a1.57,1.57,0,0,1-.72-.69A4.39,4.39,0,0,1,160.71,322.32Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,323c-.1-.06-.5.42-.88,1.08s-.6,1.24-.49,1.3.5-.41.88-1.07S173.26,323.11,173.15,323Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,322.26c-.12,0-.5.77-1,1.75s-1,1.74-.86,1.82.73-.6,1.26-1.61A3.61,3.61,0,0,0,170,322.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.27,321.86c-.12,0-.38.72-.74,1.62s-.69,1.61-.58,1.67.63-.57,1-1.5S166.39,321.88,166.27,321.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,315.38a17.27,17.27,0,0,0-.93,3.8,16.18,16.18,0,0,0-.49,3.88,17.6,17.6,0,0,0,.94-3.8A16.45,16.45,0,0,0,162,315.38Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.74,321.06c-.05,0,0,.19.2.37a1.41,1.41,0,0,0,1.88,0c.19-.18.24-.34.19-.38s-.52.29-1.13.29S173.83,321,173.74,321.06Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.89,320.92s0,.2.26.37a1.75,1.75,0,0,0,1,.32,1.72,1.72,0,0,0,1-.32c.22-.17.3-.33.26-.38s-.58.25-1.28.24S170,320.83,169.89,320.92Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.91,318.76c0-.07-.34.21-.14.7a2.19,2.19,0,0,0,1.36,1,2.75,2.75,0,0,0,1.68-.05c.41-.16.6-.37.57-.42a5.28,5.28,0,0,1-2.12,0,2.56,2.56,0,0,1-1.21-.74C162.85,319,163,318.79,162.91,318.76Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrPolicies);
export default __webpack_public_path__ + "static/media/hr-policies.28744784fb40f16fa7319f37c5b2d2e7.svg";
export { ForwardRef as ReactComponent };